// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Generated: 2026-10-27T17:12:56.312Z
// Property: Bridges Apartment Homes (ID: 6767906449167070)
// Collections: 28 amenities, 15 floorplans (live), 19 photos, 47 POIs, 1 reviews, 1 virtual tours, 5 office hours, 1 special offers (live)
// Live collections (fetched at runtime): floorplans, special_offers

export const property = {
  "multihub_agency_id": "5680529164730368",
  "multihub_company_id": "5726763346821120",
  "multihub_property_id": "6767906449167070",
  "property_external_id": "657958",
  "property_zillow_url": null,
  "property_apartments_url": "https://www.apartments.com/bridges-apartment-homes-salt-lake-city-ut/n4lvrcp/",
  "property_google_business_url": "https://www.google.com/maps/place/Bridges+Apartment+Homes/data=!4m2!3m1!1s0x0:0xeda058693df3c0a0?sa=X&ved=2ahUKEwj1zbrcrYOTAxWRrIkEHZ8JEVgQ_BJ6BAgXEAA&hl=en&gl=us",
  "property_linkedin_url": null,
  "property_hubspot_id": null,
  "property_crm_software": "Yardi RentCafe",
  "property_pm_software": "Yardi",
  "property_pm_info": null,
  "property_status": null,
  "property_slug": "bridges-apartment-homes",
  "property_name": "Bridges Apartment Homes",
  "property_website_url": "https://www.bridgesapartmenthomes.com",
  "property_domain": "https://www.bridgesapartmenthomes.com",
  "property_address": "650 West South Temple",
  "property_full_address": "650 West South Temple, Salt Lake City, UT, 84116",
  "property_address_1": "650 West South Temple",
  "property_address_2": null,
  "property_address_city": "Salt Lake City",
  "property_address_state": "UT",
  "property_address_zip_full": null,
  "property_address_zip": "84116",
  "property_address_country": "US",
  "property_address_county": "Salt Lake County",
  "property_neighborhood_address": "Downtown",
  "property_address_latitude": "40.7699",
  "property_address_longitude": "-111.909",
  "property_email": "Bridges@Weidner.com",
  "property_phone": "(385) 396-7089",
  "property_call_tracking_phone": "801-850-9581",
  "property_company_name": "Weidner Apartment Homes",
  "property_company_url": "https://www.weidner.com/",
  "agency_contacts": null,
  "property_type": null,
  "property_short_description": "Welcome to Bridges, where comfort meets convenience in the heart of Salt Lake City. Choose from our thoughtfully designed one, two, or three-bedroom apartments, complete with modern amenities like a fitness center, pool, and in-home laundry. Experience exceptional living—schedule your tour and find your new home today!",
  "property_long_description": "Welcome to Bridges, your premier apartment community in the vibrant heart of Salt Lake City, UT! Offering a variety of spacious floor plans, including one, two, and three-bedroom apartments, we have the perfect home to suit your lifestyle. Each residence is thoughtfully designed with upgraded Energy Star-rated appliances, beautiful granite countertops, and in-home washers and dryers, ensuring comfort and convenience at every turn.\n\nAt Bridges, we believe in providing a lifestyle of leisure and comfort. Enjoy our outstanding amenities, including a welcoming clubhouse, a state-of-the-art fitness center with cardio and weight machines, a refreshing pool, and a rejuvenating year-round spa/hot tub. Our beautifully landscaped courtyards, complete with playgrounds, invite moments of relaxation, while our gated community and courtesy patrol ensure your peace of mind.\n\nWith 24-hour access, on-site management, and maintenance support, you can enjoy hassle-free living. Our property also benefits from convenient public transportation options, making it easy to explore all that Salt Lake City has to offer - including being within walking distance to the Delta Center.\n\nAdditional features such as high-speed internet access, air conditioning, ceiling fans, and large walk-in closets in select homes provide the comfort and quality you deserve. We also offer online payment options and a bilingual staff to assist residents.\n\nReady to find your new home? Browse our availability or schedule a tour today to discover what makes Bridges the ideal choice for your next apartment community! Experience the perfect blend of modern living and community vibes at Bridges, where your new lifestyle awaits!",
  "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167070/019d01b0-942d-774a-afda-9cdd5d94b284.webp",
  "property_featured_image_media": {
    "alt_text": "Exterior view of apartment buildings with manicured lawns and trees.",
    "public_id": "019d01b0-942d-774a-afda-9cdd5d94b284",
    "storage_key": "property/6767906449167070/019d01b0-942d-774a-afda-9cdd5d94b284.webp",
    "width": 1600,
    "height": 585
  },
  "property_featured_video": null,
  "property_featured_video_media": null,
  "property_total_units": "295",
  "property_year_built": "2009",
  "property_year_renovated": null,
  "property_walk_score": null,
  "property_transit_score": null,
  "property_business_hours_list": null,
  "property_current_occupancy": "94.23728813559322",
  "property_admin_fee": null,
  "property_application_fee": null,
  "property_fees_deposit_info": "300",
  "property_ispetfriendly": true,
  "property_allows_cats": true,
  "property_allows_dogs": true,
  "property_upfront_pet_fee": "200",
  "property_pet_deposit": "200",
  "property_monthly_pet_rent": "35",
  "property_max_pets": "2",
  "property_max_pet_weight_limit": "0",
  "property_pet_restrictions": "Breed restrictions apply",
  "property_pet_policy_description": "Up to 2 pets per home are welcome.",
  "property_petpolicy_info": null,
  "property_online_leasing_url": "https://bridgesapartmenthomes.securecafe.com/onlineleasing/bridges-apartment-homes/floorplans.aspx",
  "property_resident_portal_url": "https://bridgesapartmenthomes.securecafenet.com/residentservices/bridges-apartment-homes/userlogin",
  "property_apply_now_url": "https://bridgesapartmenthomes.securecafe.com/onlineleasing/bridges-apartment-homes/guestlogin.aspx",
  "property_community_amenities_list": null,
  "property_apartment_features_list": null,
  "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167070/019d01b0-a0e1-735b-bf2c-74f5f8e7743f.webp",
  "property_primary_logo_media": {
    "alt_text": "Bridges Apartment Homes logo",
    "public_id": "019d01b0-a0e1-735b-bf2c-74f5f8e7743f",
    "storage_key": "property/6767906449167070/019d01b0-a0e1-735b-bf2c-74f5f8e7743f.webp",
    "width": 151,
    "height": 75
  },
  "property_secondary_logo": null,
  "property_secondary_logo_media": null,
  "property_icon": null,
  "property_icon_media": null,
  "property_fav_icon": null,
  "property_fav_icon_media": null,
  "property_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167070/019d01b0-aaf9-755b-8fe8-ddaf80c98082.webp",
  "property_mono_white_logo_media": {
    "alt_text": "Bridges Apartment Homes logo",
    "public_id": "019d01b0-aaf9-755b-8fe8-ddaf80c98082",
    "storage_key": "property/6767906449167070/019d01b0-aaf9-755b-8fe8-ddaf80c98082.webp",
    "width": 151,
    "height": 75
  },
  "property_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167070/019d01b0-b402-7186-ab8c-8c7fca0ff5d8.webp",
  "property_mono_black_logo_media": {
    "alt_text": "Bridges Apartment Homes logo",
    "public_id": "019d01b0-b402-7186-ab8c-8c7fca0ff5d8",
    "storage_key": "property/6767906449167070/019d01b0-b402-7186-ab8c-8c7fca0ff5d8.webp",
    "width": 151,
    "height": 75
  },
  "property_company_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5726763346821120/019d0198-4291-7593-82c0-efd4c864db24.webp",
  "property_company_icon_media": null,
  "property_company_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5726763346821120/019d0198-5322-7081-947b-e809ba802b6c.webp",
  "property_company_logo_media": {
    "alt_text": "Weidner Apartment Homes logo",
    "public_id": "019d0198-5322-7081-947b-e809ba802b6c",
    "storage_key": "company/5726763346821120/019d0198-5322-7081-947b-e809ba802b6c.webp",
    "width": 1342,
    "height": 402
  },
  "property_company_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5726763346821120/019d270e-bdc5-779e-a400-a391326cc801.webp",
  "property_company_mono_black_logo_media": {
    "alt_text": "Weidner Apartment Homes logo",
    "public_id": "019d270e-bdc5-779e-a400-a391326cc801",
    "storage_key": "company/5726763346821120/019d270e-bdc5-779e-a400-a391326cc801.webp",
    "width": 640,
    "height": 192
  },
  "property_company_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5726763346821120/019d270e-c548-748f-97de-b042810ed358.webp",
  "property_company_mono_white_logo_media": {
    "alt_text": "Weidner Apartment Homes logo",
    "public_id": "019d270e-c548-748f-97de-b042810ed358",
    "storage_key": "company/5726763346821120/019d270e-c548-748f-97de-b042810ed358.webp",
    "width": 640,
    "height": 192
  },
  "property_primary_color": "#b5b3a6",
  "property_secondary_color": "#dd5658",
  "property_font_color": null,
  "property_color_4": null,
  "property_color_3": "#1c1f30",
  "property_color_5": null,
  "property_color_6": null,
  "property_color_7": null,
  "property_color_8": null,
  "property_bedrooms_range": "1 - 3",
  "property_bedrooms_min": "1",
  "property_bedrooms_max": "3",
  "property_bathrooms_range": "1 - 2",
  "property_bathrooms_min": "1",
  "property_bathrooms_max": "2",
  "property_sqft_range": " - 1185",
  "property_sqft_min": "744",
  "property_sqft_max": "1185",
  "property_price_range": "1095 - 2695",
  "property_price_min": "1095",
  "property_price_max": "2695",
  "property_available_units": 34,
  "property_facebook_url": "https://www.facebook.com/BridgesApartmentHomes/",
  "property_instagram_url": "https://www.instagram.com/bridgesapthomes/",
  "property_twitter_url": null,
  "property_google_place_url": "https://www.google.com/maps/place/?q=place_id:ChIJEyau5VX0UocRoMDzPWlYoO0",
  "property_youtube_url": "https://www.youtube.com/@WeidnerApartmentHomes",
  "property_yelp_url": null,
  "property_tiktok_url": null,
  "property_specialoffer_title": null,
  "property_specialoffer_description": null,
  "property_specialoffer_disclaimer": null,
  "property_home_hero_title": "Welcome to Bridges",
  "property_home_romance_title": "Create Lasting Memories in Your Ideal Apartment Home Today",
  "property_home_amenities_blurb": "At Bridges in Salt Lake City, experience unparalleled living with spacious one, two, and three-bedroom floor plans. Enjoy modern amenities like a sparkling pool, fully-equipped fitness center, and inviting clubhouse. With 24-hour access, maintenance on-site, and energy-efficient features, community living meets comfort and convenience. Your dream apartment awaits!",
  "property_home_floorplans_blurb": "Welcome to Bridges in the heart of Salt Lake City, UT, where modern living meets comfort. With a variety of thoughtfully designed floor plans, you'll find the ideal space that suits your lifestyle. Browse our available apartment homes today and discover the perfect setting for your next chapter.",
  "property_home_gallery_blurb": "At Bridges in Salt Lake City, you can embrace comfort and style with versatile one, two, and three-bedroom floor plans. Enjoy on-site amenities like a fitness center, sparkling pool, and charming courtyards—all within a gated community. Picture yourself living here, where every detail is designed for your comfort.",
  "property_home_neighborhood_blurb": "Welcome to Bridges, your gateway to vibrant Salt Lake City living. Nestled near top local attractions like the Natural History Museum of Utah and the historic Temple Square, our one, two, and three-bedroom apartments blend comfort with community. Embrace city life and enjoy your tranquil haven!",
  "property_home_reviews_blurb": "At Bridges in Salt Lake City, residents rave about the \"welcoming atmosphere and attentive staff.\" Experience a community where comfort meets convenience and enjoy a lifestyle that enriches your daily living. See what our residents have to say about living at our community! Your new home awaits.",
  "property_neighborhood_blurb": "At Bridges in Salt Lake City, vibrant living meets convenience. Nestled near cultural gems like the Natural History Museum of Utah and the iconic Temple Square, our community offers one, two, and three-bedroom apartments surrounded by parks, universities, and fitness centers. Embrace your new lifestyle and connect with local favorites!",
  "property_accessibility_blurb": null,
  "property_amenities_blurb": "Welcome to Bridges in vibrant Salt Lake City, UT, where comfort meets convenience. Choose from spacious one, two, and three-bedroom floor plans. Enjoy 24-hour access, a resort-style pool, and a fully equipped fitness center. With upscale features and community-focused amenities, your ideal apartment lifestyle awaits!",
  "property_applynow_blurb": "At Bridges in Salt Lake City, our thoughtfully designed one, two, and three-bedroom floor plans offer modern comfort and style. Enjoy exclusive amenities like a relaxing pool, fitness center, and inviting clubhouse. Experience the convenience of online rent payment and 24-hour access. Your dream home awaits—lease online today!",
  "property_contactus_blurb": "At Bridges in Salt Lake City, UT, we offer thoughtfully designed one, two, and three-bedroom floor plans that cater to your lifestyle. Each apartment combines comfort and style, creating a perfect haven. Have questions? Our leasing team is ready to assist you—reach out today!",
  "property_faqs_blurb": "At Bridges in Salt Lake City, discover a harmonious blend of comfort and style with our diverse floor plans. Whether you're seeking a cozy one-bedroom or a spacious three-bedroom, we cater to all lifestyles. Have questions? Visit our FAQs page for insights into our vibrant community and make informed choices.",
  "property_floorplans_blurb": "Welcome to Bridges in Salt Lake City, UT, where comfort meets style. Choose from our thoughtfully designed one, two, and three-bedroom floor plans, each tailored to your needs. Embrace a new lifestyle—browse our available apartment homes and find the layout that suits you best today!",
  "property_gallery_blurb": "Immerse yourself in the inviting lifestyle at Bridges in Salt Lake City, UT. Our diverse floor plans, featuring one to three-bedroom options, offer stylish comfort with modern amenities like a fitness center, pool, and serene courtyards. Picture yourself enjoying chic interiors and convenient access to public transport. Your new home awaits!",
  "property_interactivemap_blurb": "At Bridges in Salt Lake City, choose from spacious one, two, or three-bedroom apartments amenity-rich for comfort and style. Enjoy 24-hour access, a sparkling pool, and a fitness center, all within walking distance of the Delta Center. Use our interactive community map to find your perfect home today!",
  "property_pets_blurb": "At Bridges in vibrant Salt Lake City, your furry friends are embraced with open arms! With a welcoming pet policy, you can bring up to two cats or dogs to enjoy our community. Indulge in the ultimate pet-friendly living experience where every tail wag and purr is celebrated.",
  "property_referafriend_blurb": "At Bridges in Salt Lake City, UT, finding your perfect home is a breeze with our diverse floor plans, including one, two, and three-bedroom options. Share the joy of comfortable living—refer a friend to our community today and cultivate a neighborhood where great friends make great neighbors!",
  "property_residentaccess_blurb": "Welcome to Bridges in Salt Lake City, UT, where your ideal home awaits! Choose from our thoughtfully designed one, two, or three-bedroom floor plans that perfectly match your lifestyle. Log in to your resident portal for seamless rent payments, effortless maintenance requests, and exclusive community updates. Your comfort is our priority!",
  "property_reviews_blurb": "At Bridges in Salt Lake City, UT, our residents rave about the vibrant community atmosphere, stating, “The staff truly makes you feel at home.\" Join a welcoming community where comfort and convenience intersect. See what our residents have to say about living at our community!",
  "property_created_at": "1771526135569",
  "property_scheduletour_blurb": "At Bridges in Salt Lake City, UT, our thoughtfully designed one, two, and three-bedroom apartments offer the perfect blend of comfort and style. Experience community living at its best and hear firsthand from our residents about what makes Bridges their home. Ready to see for yourself? Schedule a tour today!",
  "property_thankyou_blurb": "Thank you for reaching out to Bridges in Salt Lake City! Your interest in our spacious one, two, and three-bedroom floor plans is greatly appreciated. A member of our team will connect with you soon to help you explore your future home in our vibrant community. Stay tuned!",
  "property_virtualtours_blurb": "Step into Bridges, your ideal Salt Lake City retreat, where modern living meets comfort! With thoughtfully designed one, two, and three-bedroom floor plans, you’re bound to find the perfect fit. Ready to see for yourself? Take a virtual tour of our vibrant community and apartments for rent today!",
  "property_copyright": "2026 All Rights Reserved. Bridges",
  "property_seo_title_home": "Bridges |  Apartments in Salt Lake City, UT",
  "property_seo_description_home": "Discover modern living at Bridges in Salt Lake City with spacious one to three-bedroom apartments and top-tier amenities. Your perfect home awaits!",
  "property_seo_title_floorplans": "Floor Plans | Salt Lake City, UT Apartments for Rent",
  "property_seo_description_floorplans": "Find your ideal space at Bridges in Salt Lake City! Choose from stylish one, two, or three-bedroom floor plans. Your new home awaits—browse now!",
  "property_seo_title_amenities": "Amenities | Salt Lake City, UT Apartments for Rent",
  "property_seo_description_amenities": "Experience modern living at Bridges in Salt Lake City, UT. Enjoy upscale amenities, spacious floor plans, and a vibrant community designed for your lifestyle.",
  "property_seo_title_gallery": "Gallery | Apartments in Salt Lake City, UT",
  "property_seo_description_gallery": "Elevate your lifestyle at Bridges in Salt Lake City! View stunning photo galleries of our spacious apartments and vibrant amenities. Picture your new home!",
  "property_seo_title_virtualtours": "Virtual Tours | Bridges Apartments",
  "property_seo_description_virtualtours": "Experience life at Bridges in Salt Lake City! Take a virtual tour of our vibrant community and explore our unique one to three-bedroom apartments.",
  "property_seo_title_interactivemap": "Interactive Map | Bridges Apartments",
  "property_seo_description_interactivemap": "Uncover your perfect home at Bridges in Salt Lake City! Use our interactive map to browse one, two, or three-bedroom apartments with top-notch amenities.",
  "property_seo_title_neighborhood": "Neighborhood | Apartments in Salt Lake City, UT",
  "property_seo_description_neighborhood": "Uncover the vibrant Salt Lake City neighborhood surrounding Bridges. From local favorites to must-see spots, see what makes our community truly special!",
  "property_seo_title_contact": "Contact Us | Bridges",
  "property_seo_description_contact": "Connect with Bridges in Salt Lake City! Whether you're looking for a one, two, or three-bedroom apartment, our leasing team is here for your inquiries!",
  "property_seo_title_faqs": "FAQs | Apartments in Salt Lake City, UT",
  "property_seo_description_faqs": "Discover answers to your questions at Bridges, Salt Lake City! Check our FAQs for details on our one-to-three-bedroom apartments and amenities.",
  "property_seo_title_reviews": "Resident Reviews | Apartments in Salt Lake City, UT",
  "property_seo_description_reviews": "Experience the thriving community at Bridges in Salt Lake City. See what our residents love about their homes, from amenities to floor plans. Join us today!",
  "property_seo_title_applynow": "Apply Now | Apartments in Salt Lake City, UT",
  "property_seo_description_applynow": "Experience modern living at Bridges in Salt Lake City! Choose from spacious one to three-bedroom plans with top-tier amenities. Apply online today!",
  "property_seo_title_residentaccess": "Resident Access | Bridges",
  "property_seo_description_residentaccess": "Log in to Bridges' resident portal for seamless rent payments, easy maintenance requests, and to connect with your Salt Lake City community!",
  "property_seo_title_referafriend": "Refer A Friend | Bridges",
  "property_seo_description_referafriend": "Great friends make great neighbors! Refer a friend to Bridges in Salt Lake City and enjoy cozy living, rewarding connections, and vibrant community life.",
  "property_seo_title_scheduletour": "Schedule a Tour | Bridges",
  "property_seo_description_scheduletour": "Experience vibrant living at Bridges in Salt Lake City. Schedule your tour today and step into a community where comfort and convenience come together!",
  "property_seo_title_privacy": "Privacy Policy | Bridges",
  "property_seo_description_privacy": "At Bridges in Salt Lake City, your privacy matters. Read our policy to learn how we protect your data and ensure a secure, comfortable living experience.",
  "property_seo_title_accessibility": "Website Accessibility | Bridges",
  "property_seo_description_accessibility": "At Bridges in Salt Lake City, we prioritize digital inclusion for all. Join us in creating a welcoming community space!",
  "property_seo_title_sitemap": "Sitemap | Bridges",
  "property_seo_description_sitemap": "Navigate the vibrant life at Bridges in Salt Lake City! Check our sitemap to uncover your future home and explore the many amenities awaiting you.",
  "property_seo_title_thankyou": "Thank You | Bridges",
  "property_seo_description_thankyou": "Thank you for your interest in Bridges! Our team will reach out soon to help you find your perfect home in the heart of Salt Lake City. Stay tuned!",
  "property_seo_title_pets": "Pet Policy | Apartments in Salt Lake City, UT",
  "property_seo_description_pets": "Discover our comprehensive pet policy designed to ensure a comfortable and welcoming environment for you and your furry companions.",
  "property_updated_at": "1791293631558",
  "amenities": [
    {
      "id": "ec_855d385e3568a3ed177755b5",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167070",
      "source": "generator",
      "external_id": "false",
      "title": "Resort‑style outdoor pool",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_df3b4bab1c1f71f004d0d438",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167070",
      "source": "generator",
      "external_id": "false",
      "title": "Spa/hot tub",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_36aad384e6ad985e0efb50b1",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167070",
      "source": "generator",
      "external_id": "false",
      "title": "Clubhouse and shared gourmet kitchen",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_8157f552706db842bedf52be",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167070",
      "source": "generator",
      "external_id": "false",
      "title": "On‑site fitness center (cardio machines and weights)",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_1bb21e57f6a9b2a3039094e0",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167070",
      "source": "generator",
      "external_id": "false",
      "title": "Covered or garage parking",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_79810232133d37a480c1e216",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167070",
      "source": "generator",
      "external_id": "false",
      "title": "Night security patrol",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_e992064c172f5494af864650",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167070",
      "source": "generator",
      "external_id": "false",
      "title": "Pet‑friendly and smoke‑free community",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_c3126187055c597c5c250213",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167070",
      "source": "generator",
      "external_id": "false",
      "title": "Controlled‑access building",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_1fdd5cd266f40ef2aae8c104",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167070",
      "source": "generator",
      "external_id": "false",
      "title": "In‑Home Washer/Dryer",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_8118473ef983c2d602de856f",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167070",
      "source": "generator",
      "external_id": "false",
      "title": "Upgraded Energy Star Rated Apartments",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_8a26c50621da0a73f1e92aa6",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167070",
      "source": "generator",
      "external_id": "false",
      "title": "Views in Select Homes",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_86977bc1e565f923bd39d787",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167070",
      "source": "generator",
      "external_id": "false",
      "title": "Window Coverings",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_9039bf2fece4567ac852fb13",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167070",
      "source": "generator",
      "external_id": "false",
      "title": "Patio/Balcony",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_24dadcfb3b09668599b0714f",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167070",
      "source": "generator",
      "external_id": "false",
      "title": "Ceiling Fan",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_a07d8b5e67b5d67995cff679",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167070",
      "source": "generator",
      "external_id": "false",
      "title": "Air Conditioner",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_332e8abf5ed1e9d29c09fc16",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167070",
      "source": "generator",
      "external_id": "false",
      "title": "Microwave",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_07423cd931fc865e62e8da46",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167070",
      "source": "generator",
      "external_id": "false",
      "title": "Dishwasher",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_7efe0cded0fda7b80673b5d2",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167070",
      "source": "generator",
      "external_id": "false",
      "title": "Garbage Disposal",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_6b4d1ce38b47878936e78bbf",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167070",
      "source": "generator",
      "external_id": "false",
      "title": "Walk‑In Closet In Select Homes",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_efc4d00dcf86d256196f634b",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167070",
      "source": "generator",
      "external_id": "false",
      "title": "Granite Countertops",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_eb8c723309b6eb86b2ca9733",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167070",
      "source": "generator",
      "external_id": "false",
      "title": "Energy Efficient Appliances",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_041b06ef9716707331ce47d7",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167070",
      "source": "generator",
      "external_id": "false",
      "title": "Nine Foot Ceilings",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_c608734b17b4d5b939bc75e5",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167070",
      "source": "generator",
      "external_id": "false",
      "title": "Breakfast Nook",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_d4ce0deef120b6c8a619609c",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167070",
      "source": "generator",
      "external_id": "false",
      "title": "Kitchen Island",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_4b738ac2ca5afb4420e441f8",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167070",
      "source": "generator",
      "external_id": "false",
      "title": "Black Kitchen Appliances",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_79b2515b0dd444eb06b791ae",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167070",
      "source": "generator",
      "external_id": "false",
      "title": "Electric Stove/Range",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_6687033a8e8d80ed06aa3f3e",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167070",
      "source": "generator",
      "external_id": "false",
      "title": "Central AC and Heating per Apartment",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_34dd2f6ba3ebea481b3d9cba",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167070",
      "source": "generator",
      "external_id": "false",
      "title": "Linen Closet in Select Homes",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    }
  ],
  "photo_gallery": [
    {
      "id": "ec_12a95e74dcc2c90f9acd8488",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167070",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167070/01a1324f-55dc-7638-9c22-a25967d685ae.webp",
      "image_media": {
        "alt_text": "Kitchen with wood cabinets, granite countertops, and a breakfast bar.",
        "public_id": "01a1324f-55dc-7638-9c22-a25967d685ae",
        "storage_key": "property/6767906449167070/01a1324f-55dc-7638-9c22-a25967d685ae.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Spacious kitchen featuring elegant wood cabinetry, granite countertops, and a convenient breakfast bar perfect for casual dining.",
      "link": "false",
      "alt_text": "Kitchen with wood cabinets, granite countertops, and a breakfast bar.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/UT_Bridges_Favorites (33).jpg"
    },
    {
      "id": "ec_e50b1572d1d97e2b33b1e1ec",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167070",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167070/01a1324f-78f8-7167-b909-bde99c0fd0a5.webp",
      "image_media": {
        "alt_text": "Kitchen with granite countertops, wood cabinets, stainless steel sink, black appliances, and pendant lighting.",
        "public_id": "01a1324f-78f8-7167-b909-bde99c0fd0a5",
        "storage_key": "property/6767906449167070/01a1324f-78f8-7167-b909-bde99c0fd0a5.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Modern kitchen featuring granite countertops, ample wood cabinetry, a deep stainless steel sink, and a full suite of black appliances, including a refrigerator, stove, and microwave.",
      "link": "false",
      "alt_text": "Kitchen with granite countertops, wood cabinets, stainless steel sink, black appliances, and pendant lighting.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/UT_Bridges_Favorites (30).jpg"
    },
    {
      "id": "ec_ee50a07e4239ff20f6203fb0",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167070",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167070/01a1324f-869d-70ef-a8a7-97df73759908.webp",
      "image_media": {
        "alt_text": "Kitchen with granite countertops, stainless steel sink, dishwasher, and wooden cabinets.",
        "public_id": "01a1324f-869d-70ef-a8a7-97df73759908",
        "storage_key": "property/6767906449167070/01a1324f-869d-70ef-a8a7-97df73759908.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Modern kitchen featuring granite countertops, a spacious island with a sink and dishwasher, and warm wooden cabinetry. Perfect for cooking and entertaining.",
      "link": "false",
      "alt_text": "Kitchen with granite countertops, stainless steel sink, dishwasher, and wooden cabinets.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/UT_Bridges_Favorites (34).jpg"
    },
    {
      "id": "ec_f0a64530627cd6d4f6ec3dc2",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167070",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167070/01a1324f-8b56-739e-bc29-ac5e773a9c97.webp",
      "image_media": {
        "alt_text": "Kitchen and living area of an apartment",
        "public_id": "01a1324f-8b56-739e-bc29-ac5e773a9c97",
        "storage_key": "property/6767906449167070/01a1324f-8b56-739e-bc29-ac5e773a9c97.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Open-concept living and kitchen area with wood floors, granite countertops, and modern appliances. Perfect for entertaining.",
      "link": "false",
      "alt_text": "Kitchen and living area of an apartment",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/UT_Bridges_Favorites (29).jpg"
    },
    {
      "id": "ec_70963dca5dc46621ddd6d6d4",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167070",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167070/01a1324f-46e7-74ba-b4c6-4a15666a9a94.webp",
      "image_media": {
        "alt_text": "Kitchen and living room with hardwood floors and a view of the balcony.",
        "public_id": "01a1324f-46e7-74ba-b4c6-4a15666a9a94",
        "storage_key": "property/6767906449167070/01a1324f-46e7-74ba-b4c6-4a15666a9a94.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Open-concept living area with a breakfast bar, sleek kitchen, and access to a private balcony. Perfect for modern living.",
      "link": "false",
      "alt_text": "Kitchen and living room with hardwood floors and a view of the balcony.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/UT_Bridges_Favorites (35).jpg"
    },
    {
      "id": "ec_216324750c017848862d932e",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167070",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167070/01a1324f-248f-727b-9f69-96daf55c2c00.webp",
      "image_media": {
        "alt_text": "Living room and kitchen area with a breakfast bar",
        "public_id": "01a1324f-248f-727b-9f69-96daf55c2c00",
        "storage_key": "property/6767906449167070/01a1324f-248f-727b-9f69-96daf55c2c00.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Spacious living room with hardwood floors and an open-concept kitchen, perfect for entertaining.",
      "link": "false",
      "alt_text": "Living room and kitchen area with a breakfast bar",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/UT_Bridges_Favorites (32).jpg"
    },
    {
      "id": "ec_967f34fe24c55675f478e89c",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167070",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167070/01a1324f-7f42-711d-b3de-b7324da1800a.webp",
      "image_media": {
        "alt_text": "Bedroom with a closet and a view into a bathroom.",
        "public_id": "01a1324f-7f42-711d-b3de-b7324da1800a",
        "storage_key": "property/6767906449167070/01a1324f-7f42-711d-b3de-b7324da1800a.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Step into a spacious bedroom, complete with a walk-in closet and an adjoining bathroom for ultimate convenience and privacy. Enjoy the plush carpeting and neutral tones that create a serene atmosphere.",
      "link": "false",
      "alt_text": "Bedroom with a closet and a view into a bathroom.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/UT_Bridges_Favorites (31).jpg"
    },
    {
      "id": "ec_190c41e9cec669199c1ab7e3",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167070",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167070/019d01ae-6d7a-7307-b399-9087cee450a3.webp",
      "image_media": {
        "alt_text": "Empty bedroom with closet and adjoining hallway.",
        "public_id": "019d01ae-6d7a-7307-b399-9087cee450a3",
        "storage_key": "property/6767906449167070/019d01ae-6d7a-7307-b399-9087cee450a3.webp",
        "width": 1024,
        "height": 683
      },
      "title": "Apartment",
      "description": "This is an empty bedroom with a closet, perfect for making your own. The adjoining hallway leads to additional storage or another room.",
      "link": "false",
      "alt_text": "Empty bedroom with closet and adjoining hallway.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/UT_Bridges_Favorites (18).jpg"
    },
    {
      "id": "ec_dd4e0205eda001c352f5bdc6",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167070",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167070/01a1324f-8b7e-7503-9929-021b10c59cf7.webp",
      "image_media": {
        "alt_text": "Bathroom with vanity, toilet, and bathtub with shower curtain.",
        "public_id": "01a1324f-8b7e-7503-9929-021b10c59cf7",
        "storage_key": "property/6767906449167070/01a1324f-8b7e-7503-9929-021b10c59cf7.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "A well-appointed bathroom featuring a granite-topped vanity, a white toilet, and a bathtub/shower combination with a striped curtain.",
      "link": "false",
      "alt_text": "Bathroom with vanity, toilet, and bathtub with shower curtain.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/UT_Bridges_Favorites (36).jpg"
    },
    {
      "id": "ec_ec8c8a88ecc6f98c9afef879",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167070",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167070/01a1324f-58ee-72ab-a218-1a0d84cb0c48.webp",
      "image_media": {
        "alt_text": "Washer and dryer unit with a kitchen area visible through doorway.",
        "public_id": "01a1324f-58ee-72ab-a218-1a0d84cb0c48",
        "storage_key": "property/6767906449167070/01a1324f-58ee-72ab-a218-1a0d84cb0c48.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Convenient in-unit washer and dryer, adjacent to a fully equipped kitchen with appliances and ample cabinet space.",
      "link": "false",
      "alt_text": "Washer and dryer unit with a kitchen area visible through doorway.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/UT_Bridges_Favorites (37).jpg"
    },
    {
      "id": "ec_b461b2b2d35afdc16b2f065c",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167070",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167070/019d01ae-8644-73c5-8a5a-16557e577a84.webp",
      "image_media": {
        "alt_text": "Reception desk area with computers and seating, overlooking an outdoor patio.",
        "public_id": "019d01ae-8644-73c5-8a5a-16557e577a84",
        "storage_key": "property/6767906449167070/019d01ae-8644-73c5-8a5a-16557e577a84.webp",
        "width": 1024,
        "height": 683
      },
      "title": "Community",
      "description": "Welcome to our leasing office! Our friendly staff is ready to assist you with any questions you may have about our apartments.",
      "link": "false",
      "alt_text": "Reception desk area with computers and seating, overlooking an outdoor patio.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/UT_Bridges_Favorites (19).jpg"
    },
    {
      "id": "ec_282da6c720f8c7569d584e7e",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167070",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167070/01a1324f-9d0b-737a-bea2-cf043619dd6c.webp",
      "image_media": {
        "alt_text": "Fitness center with treadmills, ellipticals, and stationary bikes.",
        "public_id": "01a1324f-9d0b-737a-bea2-cf043619dd6c",
        "storage_key": "property/6767906449167070/01a1324f-9d0b-737a-bea2-cf043619dd6c.webp",
        "width": 3072,
        "height": 1728
      },
      "title": "Community",
      "description": "Stay active in our state-of-the-art fitness center, featuring a variety of cardio machines and strength training equipment.",
      "link": "false",
      "alt_text": "Fitness center with treadmills, ellipticals, and stationary bikes.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/UT_Bridges_Favorites (27).jpg"
    },
    {
      "id": "ec_be860de320ecbc18878ab405",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167070",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167070/01a1324f-a1d9-721c-8069-a62982ccf5a7.webp",
      "image_media": {
        "alt_text": "Fitness center with cardio machines and ping pong table",
        "public_id": "01a1324f-a1d9-721c-8069-a62982ccf5a7",
        "storage_key": "property/6767906449167070/01a1324f-a1d9-721c-8069-a62982ccf5a7.webp",
        "width": 3072,
        "height": 1728
      },
      "title": "Community",
      "description": "Stay active and have fun in our fully equipped fitness center, featuring cardio machines and a recreational ping pong table for residents to enjoy.",
      "link": "false",
      "alt_text": "Fitness center with cardio machines and ping pong table",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/UT_Bridges_Favorites (26).jpg"
    },
    {
      "id": "ec_d161ae5f96f5189dad4e9e65",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167070",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167070/01a1324f-b2c4-720d-b2c5-bbf16a672f4c.webp",
      "image_media": {
        "alt_text": "Gym with treadmills and weight machines",
        "public_id": "01a1324f-b2c4-720d-b2c5-bbf16a672f4c",
        "storage_key": "property/6767906449167070/01a1324f-b2c4-720d-b2c5-bbf16a672f4c.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "State-of-the-art fitness center with cardio machines and weight-lifting equipment for resident use.",
      "link": "false",
      "alt_text": "Gym with treadmills and weight machines",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/UT_Bridges_Favorites (28).jpg"
    },
    {
      "id": "ec_ccf1c026d3237a060379eba2",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167070",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167070/01a1324f-a59b-718d-a270-0957d4b4f82a.webp",
      "image_media": {
        "alt_text": "Community lounge area with ping pong table and seating",
        "public_id": "01a1324f-a59b-718d-a270-0957d4b4f82a",
        "storage_key": "property/6767906449167070/01a1324f-a59b-718d-a270-0957d4b4f82a.webp",
        "width": 3072,
        "height": 1728
      },
      "title": "Community",
      "description": "Enjoy leisure time in the community lounge, featuring a ping pong table and comfortable seating areas.",
      "link": "false",
      "alt_text": "Community lounge area with ping pong table and seating",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/UT_Bridges_Favorites (24).jpg"
    },
    {
      "id": "ec_6a785e965ed0a06ca76c0309",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167070",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167070/01a1324f-9a59-72ef-b100-491e3cdc2b4d.webp",
      "image_media": {
        "alt_text": "Community lounge with bar, seating area, and ping pong table.",
        "public_id": "01a1324f-9a59-72ef-b100-491e3cdc2b4d",
        "storage_key": "property/6767906449167070/01a1324f-9a59-72ef-b100-491e3cdc2b4d.webp",
        "width": 3072,
        "height": 1728
      },
      "title": "Community",
      "description": "Gather with friends and neighbors in our spacious community lounge, complete with a full-service bar, comfortable seating areas, and entertainment options like a ping pong table.",
      "link": "false",
      "alt_text": "Community lounge with bar, seating area, and ping pong table.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/UT_Bridges_Favorites (22).jpg"
    },
    {
      "id": "ec_e665937524254ee50d9ae52b",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167070",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167070/019d01ae-95bc-73b8-a11e-5c786dd0b990.webp",
      "image_media": {
        "alt_text": "Playground with slides and climbing structure fenced in, next to apartment buildings.",
        "public_id": "019d01ae-95bc-73b8-a11e-5c786dd0b990",
        "storage_key": "property/6767906449167070/019d01ae-95bc-73b8-a11e-5c786dd0b990.webp",
        "width": 1024,
        "height": 683
      },
      "title": "Community",
      "description": "Enjoy outdoor fun at our community playground, perfect for families and children.",
      "link": "false",
      "alt_text": "Playground with slides and climbing structure fenced in, next to apartment buildings.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/UT_Bridges_Favorites (23).jpg"
    },
    {
      "id": "ec_0fc17f2e11708965d5d884b4",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167070",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167070/019d01ae-8898-729e-bd67-3db8b3cda660.webp",
      "image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and umbrellas, surrounded by apartment buildings.",
        "public_id": "019d01ae-8898-729e-bd67-3db8b3cda660",
        "storage_key": "property/6767906449167070/019d01ae-8898-729e-bd67-3db8b3cda660.webp",
        "width": 1024,
        "height": 683
      },
      "title": "Community",
      "description": "Enjoy a relaxing dip in our sparkling swimming pool, complete with comfortable lounge chairs and shaded umbrellas. Perfect for a sunny afternoon.",
      "link": "false",
      "alt_text": "Resort-style swimming pool with lounge chairs and umbrellas, surrounded by apartment buildings.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/UT_Bridges_Favorites (21).jpg"
    },
    {
      "id": "ec_e7ea1e7bd3546778d2770113",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167070",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167070/019d01ae-943f-7088-b5e9-c853a7626a22.webp",
      "image_media": {
        "alt_text": "Bridges Apartment Homes monument sign with landscaping and trees.",
        "public_id": "019d01ae-943f-7088-b5e9-c853a7626a22",
        "storage_key": "property/6767906449167070/019d01ae-943f-7088-b5e9-c853a7626a22.webp",
        "width": 1024,
        "height": 683
      },
      "title": "Community",
      "description": "Welcome to Bridges Apartment Homes, a vibrant community offering comfortable living spaces and convenient amenities.",
      "link": "false",
      "alt_text": "Bridges Apartment Homes monument sign with landscaping and trees.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/UT_Bridges_Favorites (20).jpg"
    }
  ],
  "neighborhood_pois": [
    {
      "id": "custom_6ab43d8e-551e-4f36-84f7-f3de9ba88fef",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167070",
      "source": "custom",
      "poi_name": "In-N-Out Burger",
      "poi_type": "Restaurants",
      "poi_address": "28 E 2100 S, South Salt Lake, UT 84115, USA",
      "poi_short_description": "Classic burger chain serving customizable burgers, hand-cut fries & shakes.",
      "poi_long_description": "Diners say this hamburger restaurant serves delicious cheeseburgers, fries, and shakes. They also highlight the friendly and efficient service, and the fresh, affordable food.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167070/019d01af-b555-732b-a93a-6121d0d6dcf9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01af-b555-732b-a93a-6121d0d6dcf9",
        "storage_key": "property/6767906449167070/019d01af-b555-732b-a93a-6121d0d6dcf9.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://locations.in-n-out.com/418",
      "poi_directions_map_url": "https://maps.google.com/?cid=2202806748596295407&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "in-n-out-burger",
      "poi_latitude": "40.7252224",
      "poi_longitude": "-111.8902564",
      "poi_miles_from_property": "4.1",
      "poi_walking_minutes": "1 hour 32 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 800-786-1000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167070/019d01af-74d4-725f-9cbe-fca4bb0a9ab6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01af-74d4-725f-9cbe-fca4bb0a9ab6",
        "storage_key": "property/6767906449167070/019d01af-74d4-725f-9cbe-fca4bb0a9ab6.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJKxncBeKLUocR71bqHhHxkR4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hamburger_restaurant"
    },
    {
      "id": "custom_ab21c8cc-f550-468e-8be0-9000a7ccbe69",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167070",
      "source": "custom",
      "poi_name": "Slackwater Pizza SLC",
      "poi_type": "Restaurants",
      "poi_address": "684 S 500 W, Salt Lake City, UT 84101, USA",
      "poi_short_description": "Casual pizza joint with a large beer selection, featuring some pies with unique flavor combinations.",
      "poi_long_description": "People say this restaurant serves delicious pizza with a unique, slightly sweet dough, as well as a wide selection of craft beers, wings, and other appetizers. They highlight the fun, lively atmosphere, and the friendly, attentive staff. They also like the reasonable prices and the expansive menu with gluten-free options.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167070/019d01af-b53f-768f-9801-0c1a24914522.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01af-b53f-768f-9801-0c1a24914522",
        "storage_key": "property/6767906449167070/019d01af-b53f-768f-9801-0c1a24914522.webp",
        "width": 1280,
        "height": 854
      },
      "poi_business_url": "http://www.slackwaterpizzeria.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14951801590224390378&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "slackwater-pizza-slc",
      "poi_latitude": "40.75444299999999",
      "poi_longitude": "-111.9056934",
      "poi_miles_from_property": "1.3",
      "poi_walking_minutes": "29 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 801-386-9777",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167070/019d01af-74d4-725f-9cbe-fca4bb0a9ab6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01af-74d4-725f-9cbe-fca4bb0a9ab6",
        "storage_key": "property/6767906449167070/019d01af-74d4-725f-9cbe-fca4bb0a9ab6.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJx1ccyxz1UocR6ghyCVR4f88",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_75244279-c094-4fb4-8dd9-75001d6c0d55",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167070",
      "source": "custom",
      "poi_name": "Raising Cane’s Chicken Fingers",
      "poi_type": "Restaurants",
      "poi_address": "2150 S State St, South Salt Lake, UT 84115, USA",
      "poi_short_description": "Fast-food chain specializing in fried chicken fingers, crinkle-cut fries & Texas toast.",
      "poi_long_description": "Diners say this fast food restaurant serves up delicious chicken fingers, Texas toast, and Cane's sauce, with many raving about the lemonade. They also highlight the quick and friendly service, and the affordable prices.\n\nSome reviews mention the portions can be small.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167070/019d01af-b568-735f-8203-6522bf0b2fd7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01af-b568-735f-8203-6522bf0b2fd7",
        "storage_key": "property/6767906449167070/019d01af-b568-735f-8203-6522bf0b2fd7.webp",
        "width": 720,
        "height": 720
      },
      "poi_business_url": "https://locations.raisingcanes.com/ut/south-salt-lake/2150-s-state-st",
      "poi_directions_map_url": "https://maps.google.com/?cid=18425726988590759800&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "raising-canes-chicken-fingers",
      "poi_latitude": "40.7240071",
      "poi_longitude": "-111.8888015",
      "poi_miles_from_property": "4.3",
      "poi_walking_minutes": "1 hour 36 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 801-988-0019",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167070/019d01af-74d4-725f-9cbe-fca4bb0a9ab6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01af-74d4-725f-9cbe-fca4bb0a9ab6",
        "storage_key": "property/6767906449167070/019d01af-74d4-725f-9cbe-fca4bb0a9ab6.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJlVAfT0yLUocReL9HixJVtf8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fast_food_restaurant"
    },
    {
      "id": "custom_3546e87c-bcc3-4ef9-a14e-16d5baf3750c",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167070",
      "source": "custom",
      "poi_name": "Red Iguana 2",
      "poi_type": "Restaurants",
      "poi_address": "866 W S Temple St, Salt Lake City, UT 84104, USA",
      "poi_short_description": "Happening little kitchen with a festive vibe & dishes from across Mexico, including renowned mole.",
      "poi_long_description": "People say this Mexican restaurant serves delicious mole, carne asada tacos, and enchiladas. They highlight the generous portions, fair prices, and lively atmosphere. They also like the friendly and attentive service.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167070/019d01af-b644-746e-a399-cfce37ff083c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01af-b644-746e-a399-cfce37ff083c",
        "storage_key": "property/6767906449167070/019d01af-b644-746e-a399-cfce37ff083c.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.rediguana.com/locations/red-iguana-2/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8438835085975497207&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "red-iguana-2",
      "poi_latitude": "40.769692",
      "poi_longitude": "-111.9161652",
      "poi_miles_from_property": "0.5",
      "poi_walking_minutes": "12 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 801-214-6050",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167070/019d01af-74d4-725f-9cbe-fca4bb0a9ab6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01af-74d4-725f-9cbe-fca4bb0a9ab6",
        "storage_key": "property/6767906449167070/019d01af-74d4-725f-9cbe-fca4bb0a9ab6.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJj096gVf0UocR9ymswczDHHU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "mexican_restaurant"
    },
    {
      "id": "custom_d02b33f7-9706-4d48-842b-568e8b4feab1",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167070",
      "source": "custom",
      "poi_name": "Red Iguana",
      "poi_type": "Restaurants",
      "poi_address": "736 W North Temple St, Salt Lake City, UT 84116, USA",
      "poi_short_description": "Bustling, family-run Mexican cafe serving signature mole plus traditional & gluten-free favorites.",
      "poi_long_description": "People say this Mexican restaurant serves delicious mole dishes, shrimp quesadillas, and fresh guacamole. They highlight the generous portions, reasonable prices, and vibrant atmosphere. They also like the friendly and attentive service.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167070/019d01ae-f725-72bf-adbd-7af37a7df0da.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01ae-f725-72bf-adbd-7af37a7df0da",
        "storage_key": "property/6767906449167070/019d01ae-f725-72bf-adbd-7af37a7df0da.webp",
        "width": 1280,
        "height": 948
      },
      "poi_business_url": "http://www.rediguana.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11516129657914646960&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "red-iguana",
      "poi_latitude": "40.7718053",
      "poi_longitude": "-111.9124897",
      "poi_miles_from_property": "0.3",
      "poi_walking_minutes": "7 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 801-322-1489",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167070/019d01af-74d4-725f-9cbe-fca4bb0a9ab6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01af-74d4-725f-9cbe-fca4bb0a9ab6",
        "storage_key": "property/6767906449167070/019d01af-74d4-725f-9cbe-fca4bb0a9ab6.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJm_zJw1b0UocRsOFXp-iC0Z8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "mexican_restaurant"
    },
    {
      "id": "custom_e57557f9-82f6-4b60-9ef0-2d8570792d7c",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167070",
      "source": "custom",
      "poi_name": "City Creek Center",
      "poi_type": "Shopping & Retail",
      "poi_address": "50 S Main St, Salt Lake City, UT 84101, USA",
      "poi_short_description": "Upmarket retailers & diverse, casual dining options in polished surrounds with a water fountain.",
      "poi_long_description": "People say this shopping center offers a wide selection of shops, including luxury brands and affordable options, and a large food court with diverse choices. They highlight the beautiful, clean, and well-designed layout, with indoor and outdoor spaces, water features, and a creek flowing throughout. They also like the free parking and convenient access to public transportation.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167070/019d01af-15e9-771b-b08b-1563f01bf7b6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01af-15e9-771b-b08b-1563f01bf7b6",
        "storage_key": "property/6767906449167070/019d01af-15e9-771b-b08b-1563f01bf7b6.webp",
        "width": 512,
        "height": 288
      },
      "poi_business_url": "https://shopcitycreekcenter.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1429749320349744761&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "city-creek-center",
      "poi_latitude": "40.76835699999999",
      "poi_longitude": "-111.8917171",
      "poi_miles_from_property": "1.2",
      "poi_walking_minutes": "28 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 801-521-2012",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167070/019d01af-74cf-7792-a100-0ee68cefb3ce.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01af-74cf-7792-a100-0ee68cefb3ce",
        "storage_key": "property/6767906449167070/019d01af-74cf-7792-a100-0ee68cefb3ce.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJqVbctwj1UocReX5NhW591xM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "custom_0fe17b53-191f-4c9d-8954-19fc793889a7",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167070",
      "source": "custom",
      "poi_name": "Chinatown Supermarket",
      "poi_type": "Shopping & Retail",
      "poi_address": "3390 State St #11, South Salt Lake, UT 84115, USA",
      "poi_short_description": "Well-stocked supermarket featuring fresh produce and meats, along with frozen seafood.",
      "poi_long_description": "People say this Asian grocery store offers a wide variety of fresh produce, seafood, snacks, and pantry staples, as well as dishes and gifts. They highlight the reasonable prices, authentic Asian snacks, teas, and spices, and the fun, lively, and adventurous vibe. They also like the friendly and helpful staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167070/019d01af-bb82-742e-b3ff-0b76a85d4e90.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01af-bb82-742e-b3ff-0b76a85d4e90",
        "storage_key": "property/6767906449167070/019d01af-bb82-742e-b3ff-0b76a85d4e90.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.chinatown-supermarket.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1977936213840259000&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "chinatown-supermarket",
      "poi_latitude": "40.6979988",
      "poi_longitude": "-111.8898417",
      "poi_miles_from_property": "6.1",
      "poi_walking_minutes": "2 hours 16 mins",
      "poi_biking_minutes": "33 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 801-906-8788",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167070/019d01af-74d8-711d-8667-bf698533dd96.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01af-74d8-711d-8667-bf698533dd96",
        "storage_key": "property/6767906449167070/019d01af-74d8-711d-8667-bf698533dd96.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ3fgyB_eKUocRuGdUxoEKcxs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "asian_grocery_store"
    },
    {
      "id": "custom_be461ca1-f95a-4809-93aa-b035db8c6163",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167070",
      "source": "custom",
      "poi_name": "Valley Fair Mall",
      "poi_type": "Shopping & Retail",
      "poi_address": "3601 S 2700 W, West Valley City, UT 84119, USA",
      "poi_short_description": "Popular chain retailers, Costco, JC Penney, a movie theater, a food court, restaurants & bowling.",
      "poi_long_description": "People say this shopping center offers a bowling alley, arcade, cinema, and a variety of stores, including clothing, jewelry, and shoe stores. They also highlight the clean environment, convenient location, and the presence of a food court and nearby restaurants.\n\nOther reviews mention the mall can be outdated.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167070/019d01af-bb9b-76de-a336-d563e26cd81e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01af-bb9b-76de-a336-d563e26cd81e",
        "storage_key": "property/6767906449167070/019d01af-bb9b-76de-a336-d563e26cd81e.webp",
        "width": 1280,
        "height": 855
      },
      "poi_business_url": "http://shopvalleyfair.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10434666986797163243&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "valley-fair-mall",
      "poi_latitude": "40.6936048",
      "poi_longitude": "-111.9537424",
      "poi_miles_from_property": "7.4",
      "poi_walking_minutes": "2 hours 46 mins",
      "poi_biking_minutes": "44 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 801-969-6211",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167070/019d01af-74cf-7792-a100-0ee68cefb3ce.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01af-74cf-7792-a100-0ee68cefb3ce",
        "storage_key": "property/6767906449167070/019d01af-74cf-7792-a100-0ee68cefb3ce.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJIRNkHZ2MUocR62KK2VZiz5A",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "custom_12d24a5e-fd5d-49d1-a9e5-7c99c40bb3ba",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167070",
      "source": "custom",
      "poi_name": "Trader Joe's",
      "poi_type": "Shopping & Retail",
      "poi_address": "634 E 400 S, Salt Lake City, UT 84102, USA",
      "poi_short_description": "Grocery chain with a variety of signature items, plus produce, dairy & more (most sell wine & beer).",
      "poi_long_description": "People say this grocery store offers a wide variety of unique and delicious food options, including seasonal items, fresh produce, and specialty products. They highlight the affordable prices, especially for items like eggs, hummus, and dips, and the fun, happy vibe. They also like the friendly and helpful staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167070/019d01af-bc93-73ae-bc5e-d5a808ee7dec.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01af-bc93-73ae-bc5e-d5a808ee7dec",
        "storage_key": "property/6767906449167070/019d01af-bc93-73ae-bc5e-d5a808ee7dec.webp",
        "width": 1280,
        "height": 847
      },
      "poi_business_url": "https://locations.traderjoes.com/ut/salt-lake-city/350/?utm_source=gmb&utm_medium=organic&utm_campaign=local",
      "poi_directions_map_url": "https://maps.google.com/?cid=1822967084851718382&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "trader-joes",
      "poi_latitude": "40.7596942",
      "poi_longitude": "-111.8725988",
      "poi_miles_from_property": "2.7",
      "poi_walking_minutes": "1 hour 2 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 801-359-2462",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167070/019d01af-74d8-711d-8667-bf698533dd96.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01af-74d8-711d-8667-bf698533dd96",
        "storage_key": "property/6767906449167070/019d01af-74d8-711d-8667-bf698533dd96.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJIymmPmn1UocR7ujQued6TBk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_d4ceb4e0-4dec-4bd5-9af9-34e96d873aff",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167070",
      "source": "custom",
      "poi_name": "Trader Joe's",
      "poi_type": "Shopping & Retail",
      "poi_address": "2160 S 700 E, Salt Lake City, UT 84106, USA",
      "poi_short_description": "Clean market selling Trader Joe's-brand and other items such as organic products and baked goods alongside fresh flowers.",
      "poi_long_description": "People say this grocery store offers a wide variety of unique and delicious products, including fresh produce, frozen meals, and specialty items. They highlight the fair prices, the spacious and clean layout, and the fun, festive atmosphere. They also like the friendly, helpful, and efficient staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167070/019d01af-bcd4-761a-9ecb-0a0034ade7b2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01af-bcd4-761a-9ecb-0a0034ade7b2",
        "storage_key": "property/6767906449167070/019d01af-bcd4-761a-9ecb-0a0034ade7b2.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://locations.traderjoes.com/ut/salt-lake-city/354/?utm_source=gmb&utm_medium=organic&utm_campaign=local",
      "poi_directions_map_url": "https://maps.google.com/?cid=3125485564465776435&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "trader-joes",
      "poi_latitude": "40.7239547",
      "poi_longitude": "-111.8722342",
      "poi_miles_from_property": "5.1",
      "poi_walking_minutes": "1 hour 57 mins",
      "poi_biking_minutes": "30 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 801-720-8834",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167070/019d01af-74d8-711d-8667-bf698533dd96.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01af-74d8-711d-8667-bf698533dd96",
        "storage_key": "property/6767906449167070/019d01af-74d8-711d-8667-bf698533dd96.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJs4VNLwCLUocRMweYtI_0Xys",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_26a8c4a9-2c31-423f-a1f5-0a7605201708",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167070",
      "source": "custom",
      "poi_name": "The University of Utah",
      "poi_type": "Education",
      "poi_address": "201 Presidents' Cir, Salt Lake City, UT 84112, USA",
      "poi_short_description": "This research university near the Wasatch Mountains features 100 acres of gardens plus an arboretum.",
      "poi_long_description": "This research university near the Wasatch Mountains features 100 acres of gardens plus an arboretum.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167070/019d01af-2b2f-762b-a381-4645898847e0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01af-2b2f-762b-a381-4645898847e0",
        "storage_key": "property/6767906449167070/019d01af-2b2f-762b-a381-4645898847e0.webp",
        "width": 715,
        "height": 515
      },
      "poi_business_url": "https://www.utah.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15966664552946993518&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "the-university-of-utah",
      "poi_latitude": "40.7649368",
      "poi_longitude": "-111.8421021",
      "poi_miles_from_property": "4.1",
      "poi_walking_minutes": "1 hour 40 mins",
      "poi_biking_minutes": "36 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 801-581-7200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167070/019d01af-7952-775f-8ef8-adb49ef68770.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01af-7952-775f-8ef8-adb49ef68770",
        "storage_key": "property/6767906449167070/019d01af-7952-775f-8ef8-adb49ef68770.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJG_NN6OpfUocRbgk63tD8lN0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_c1416134-1538-41d9-a02d-296c9a96a363",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167070",
      "source": "custom",
      "poi_name": "Salt Lake City Public Library",
      "poi_type": "Education",
      "poi_address": "210 E 400 S, Salt Lake City, UT 84111, USA",
      "poi_short_description": "Modern library known for its natural light & curved 6-story walkable wall built with high-UV glass.",
      "poi_long_description": "People say this public library offers a wide selection of books, computers, and a dedicated children's section with play areas. They highlight the impressive architecture, the rooftop garden with beautiful views, and the friendly and helpful staff. They also like the various programs and events, especially for children.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167070/019d01af-c07f-713e-9298-d2be9a08a5de.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01af-c07f-713e-9298-d2be9a08a5de",
        "storage_key": "property/6767906449167070/019d01af-c07f-713e-9298-d2be9a08a5de.webp",
        "width": 960,
        "height": 640
      },
      "poi_business_url": "https://services.slcpl.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=66428271525700298&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "salt-lake-city-public-library",
      "poi_latitude": "40.7600376",
      "poi_longitude": "-111.8846127",
      "poi_miles_from_property": "2",
      "poi_walking_minutes": "45 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 801-524-8200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167070/019d01af-7952-775f-8ef8-adb49ef68770.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01af-7952-775f-8ef8-adb49ef68770",
        "storage_key": "property/6767906449167070/019d01af-7952-775f-8ef8-adb49ef68770.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJr0salBP1UocRyiJVNykA7AA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "library"
    },
    {
      "id": "custom_4722c232-5bfb-44e8-aff3-9f0bdea03ab0",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167070",
      "source": "custom",
      "poi_name": "Ensign College",
      "poi_type": "Education",
      "poi_address": "95 N 300 W, Salt Lake City, UT 84101, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167070/019d01af-c146-77cb-b843-5465cb492456.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01af-c146-77cb-b843-5465cb492456",
        "storage_key": "property/6767906449167070/019d01af-c146-77cb-b843-5465cb492456.webp",
        "width": 1280,
        "height": 854
      },
      "poi_business_url": "https://www.ensign.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13914062519158002785&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "ensign-college",
      "poi_latitude": "40.7711865",
      "poi_longitude": "-111.9002464",
      "poi_miles_from_property": "0.5",
      "poi_walking_minutes": "12 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 801-524-8100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167070/019d01af-7952-775f-8ef8-adb49ef68770.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01af-7952-775f-8ef8-adb49ef68770",
        "storage_key": "property/6767906449167070/019d01af-7952-775f-8ef8-adb49ef68770.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ45sdcqr1UocRYVT9LCSuGME",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_8a58abff-6bd3-43ce-83ca-2430c73a6968",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167070",
      "source": "custom",
      "poi_name": "Westminster University",
      "poi_type": "Education",
      "poi_address": "1840 S 1300 E, Salt Lake City, UT 84105, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167070/019d01af-c431-73fd-8da5-915903950b7c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01af-c431-73fd-8da5-915903950b7c",
        "storage_key": "property/6767906449167070/019d01af-c431-73fd-8da5-915903950b7c.webp",
        "width": 1280,
        "height": 964
      },
      "poi_business_url": "https://westminsteru.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=732259226443356652&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "westminster-university",
      "poi_latitude": "40.7322206",
      "poi_longitude": "-111.8549815",
      "poi_miles_from_property": "5.5",
      "poi_walking_minutes": "2 hours 5 mins",
      "poi_biking_minutes": "33 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 801-832-2200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167070/019d01af-7952-775f-8ef8-adb49ef68770.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01af-7952-775f-8ef8-adb49ef68770",
        "storage_key": "property/6767906449167070/019d01af-7952-775f-8ef8-adb49ef68770.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJiYl3tgJgUocR7JmoA-OBKQo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_137e2acb-ed66-4f00-95f5-5b459a26fd1f",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167070",
      "source": "custom",
      "poi_name": "Salt Lake Community College (SLCC) South City Campus",
      "poi_type": "Education",
      "poi_address": "1575 S State St, Salt Lake City, UT 84115, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167070/019d01af-c56e-70f6-8044-f57dc2ff2257.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01af-c56e-70f6-8044-f57dc2ff2257",
        "storage_key": "property/6767906449167070/019d01af-c56e-70f6-8044-f57dc2ff2257.webp",
        "width": 1210,
        "height": 911
      },
      "poi_business_url": "http://slcc.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16438696433203835114&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "salt-lake-community-college-slcc-south-city-campus",
      "poi_latitude": "40.7351419",
      "poi_longitude": "-111.8854961",
      "poi_miles_from_property": "3.7",
      "poi_walking_minutes": "1 hour 23 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 801-957-3350",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167070/019d01af-7952-775f-8ef8-adb49ef68770.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01af-7952-775f-8ef8-adb49ef68770",
        "storage_key": "property/6767906449167070/019d01af-7952-775f-8ef8-adb49ef68770.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJx_rGHz71UocR6nCYX0_7IeQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_5fd95a35-a662-4e51-8bce-e93663c0d255",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167070",
      "source": "custom",
      "poi_name": "Delta Center",
      "poi_type": "Entertainment",
      "poi_address": "301 S Temple, Salt Lake City, UT 84101, USA",
      "poi_short_description": "Home to the Utah Jazz, this high-tech venue with luxury suites also hosts touring shows & concerts.",
      "poi_long_description": "People say this arena offers a variety of events, including concerts, hockey games, and basketball games. They highlight the smooth organization, attentive staff, and well-thought-out facilities, making it a top-tier venue for events. They also like the clean and well-maintained environment, and the easy access to public transportation.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167070/019d01af-c5e7-7259-a7e6-73043d02318e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01af-c5e7-7259-a7e6-73043d02318e",
        "storage_key": "property/6767906449167070/019d01af-c5e7-7259-a7e6-73043d02318e.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://www.deltacenter.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17358356562075300128&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "delta-center",
      "poi_latitude": "40.7682681",
      "poi_longitude": "-111.9010874",
      "poi_miles_from_property": "0.6",
      "poi_walking_minutes": "15 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 801-325-2000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167070/019d01af-796e-7515-b2be-b8f0e8c305a7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01af-796e-7515-b2be-b8f0e8c305a7",
        "storage_key": "property/6767906449167070/019d01af-796e-7515-b2be-b8f0e8c305a7.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJTfDrAwH1UocRILERH1NF5fA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "arena"
    },
    {
      "id": "custom_7bf7e20d-7e10-49d3-a730-d670b78ca978",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167070",
      "source": "custom",
      "poi_name": "Temple Square",
      "poi_type": "Entertainment",
      "poi_address": "50 North Temple, Salt Lake City, UT 84150, USA",
      "poi_short_description": "",
      "poi_long_description": "People say this historical landmark offers beautiful architecture, gardens, and a tabernacle with organ recitals. They highlight the peaceful and inspiring vibe, and the friendly and helpful staff. They also like the free tours and the opportunity to see the Music and the Spoken Word broadcast.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167070/019d01af-c660-7799-9fc5-d58fb6c02cd0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01af-c660-7799-9fc5-d58fb6c02cd0",
        "storage_key": "property/6767906449167070/019d01af-c660-7799-9fc5-d58fb6c02cd0.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.churchofjesuschrist.org/feature/templesquare?lang=eng&y_source=1_MzA1ODU2NjYtNzE1LWxvY2F0aW9uLndlYnNpdGU%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=10112787064908179005&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "temple-square",
      "poi_latitude": "40.7706273",
      "poi_longitude": "-111.8910873",
      "poi_miles_from_property": "1",
      "poi_walking_minutes": "26 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 801-240-8945",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167070/019d01af-796e-7515-b2be-b8f0e8c305a7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01af-796e-7515-b2be-b8f0e8c305a7",
        "storage_key": "property/6767906449167070/019d01af-796e-7515-b2be-b8f0e8c305a7.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ6Q6J5Aj1UocRPWYEdUHWV4w",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "historical_landmark"
    },
    {
      "id": "custom_b8912b8b-9c7f-41e1-ab8c-d687df22797e",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167070",
      "source": "custom",
      "poi_name": "Utah's Hogle Zoo",
      "poi_type": "Entertainment",
      "poi_address": "2600 Sunnyside Ave S, Salt Lake City, UT 84108, USA",
      "poi_short_description": "Modern, 42-acre zoo boasting hundreds of animals & tropical gardens, plus a train & carousel.",
      "poi_long_description": "People say this zoo offers a wide variety of animals, including giraffes, polar bears, and a baby gorilla, and features a carousel, train, and splash pad. They highlight the zoo is clean, easy to navigate, and not too crowded, especially on weekdays or early mornings. They also like the friendly and knowledgeable staff, and the fun shows, such as the dog show and bird show.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167070/019d01af-ca24-748b-9c16-03754d6383bb.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01af-ca24-748b-9c16-03754d6383bb",
        "storage_key": "property/6767906449167070/019d01af-ca24-748b-9c16-03754d6383bb.webp",
        "width": 1280,
        "height": 887
      },
      "poi_business_url": "https://www.hoglezoo.org/?utm_source=google&utm_medium=organic&utm_campaign=gbp",
      "poi_directions_map_url": "https://maps.google.com/?cid=8354643522834437222&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "utahs-hogle-zoo",
      "poi_latitude": "40.7503666",
      "poi_longitude": "-111.8141741",
      "poi_miles_from_property": "6",
      "poi_walking_minutes": "2 hours 24 mins",
      "poi_biking_minutes": "47 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 801-584-1700",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167070/019d01af-796e-7515-b2be-b8f0e8c305a7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01af-796e-7515-b2be-b8f0e8c305a7",
        "storage_key": "property/6767906449167070/019d01af-796e-7515-b2be-b8f0e8c305a7.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJidxheRv1UocRZpSQ6wSo8XM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "zoo"
    },
    {
      "id": "custom_e764b615-8636-4e17-8f89-05e3a98dcfbb",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167070",
      "source": "custom",
      "poi_name": "Maverik Center",
      "poi_type": "Entertainment",
      "poi_address": "3200 S Decker Lake Dr, West Valley City, UT 84119, USA",
      "poi_short_description": "Home to the Utah Grizzlies, this multipurpose arena hosts varied sports events & touring concerts.",
      "poi_long_description": "People say this arena offers a fun atmosphere for hockey games, concerts, and other events. They also highlight the helpful staff, quick entry, and comfortable seating.\n\nOther reviews mention the parking can be difficult.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167070/019d01af-ca81-7438-8271-b34ad5977d2a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01af-ca81-7438-8271-b34ad5977d2a",
        "storage_key": "property/6767906449167070/019d01af-ca81-7438-8271-b34ad5977d2a.webp",
        "width": 1280,
        "height": 964
      },
      "poi_business_url": "http://www.maverikcenter.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8557949442040994495&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "maverik-center",
      "poi_latitude": "40.7027016",
      "poi_longitude": "-111.9504089",
      "poi_miles_from_property": "6.5",
      "poi_walking_minutes": "2 hours 24 mins",
      "poi_biking_minutes": "38 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 801-988-8800",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167070/019d01af-796e-7515-b2be-b8f0e8c305a7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01af-796e-7515-b2be-b8f0e8c305a7",
        "storage_key": "property/6767906449167070/019d01af-796e-7515-b2be-b8f0e8c305a7.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ-SD6bWCLUocRvxqb8qzxw3Y",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "arena"
    },
    {
      "id": "custom_5eeb0de2-38c6-4609-842d-c01cb4b7db4d",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167070",
      "source": "custom",
      "poi_name": "Natural History Museum of Utah",
      "poi_type": "Entertainment",
      "poi_address": "301 Wakara Way, Salt Lake City, UT 84108, USA",
      "poi_short_description": "Modern venue with 10 galleries exploring earth science & Utah’s native cultures in a scenic locale.",
      "poi_long_description": "People say this natural history museum has impressive dinosaur fossils, geology exhibits, and Native American artifacts. They highlight the interactive exhibits, fun for families and adults, and the beautiful architecture and views. They also like the knowledgeable and helpful staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167070/019d01af-cac9-743f-a8c7-395c7c6b14a9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01af-cac9-743f-a8c7-395c7c6b14a9",
        "storage_key": "property/6767906449167070/019d01af-cac9-743f-a8c7-395c7c6b14a9.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://nhmu.utah.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16883338492971324750&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "natural-history-museum-of-utah",
      "poi_latitude": "40.7641297",
      "poi_longitude": "-111.8226881",
      "poi_miles_from_property": "5",
      "poi_walking_minutes": "2 hours 4 mins",
      "poi_biking_minutes": "46 mins",
      "poi_driving_minutes": "19 mins",
      "poi_business_phone": "+1 801-581-6927",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167070/019d01af-f4c8-74c2-8299-b3aa9ffbb083.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01af-f4c8-74c2-8299-b3aa9ffbb083",
        "storage_key": "property/6767906449167070/019d01af-f4c8-74c2-8299-b3aa9ffbb083.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJG1SOiItfUocRThU8WOiqTeo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_d76e3f77-5b71-42c4-999a-7c40bf7c84c4",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167070",
      "source": "custom",
      "poi_name": "EōS Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "515 S 700 E, Salt Lake City, UT 84102, USA",
      "poi_short_description": "High-value gym offering cardio and strength-training equipment, plus group fitness classes.",
      "poi_long_description": "Visitors say this gym offers a wide variety of workout equipment, including free weights, resistance machines, and cardio machines, as well as amenities like saunas, massage chairs, and 24/7 access. They also highlight the friendly and helpful staff, and the option to purchase day passes.\n\nSome reviews mention the gym can be crowded.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167070/019d01af-cb3c-75fa-a60c-80a74b6eb9ef.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01af-cb3c-75fa-a60c-80a74b6eb9ef",
        "storage_key": "property/6767906449167070/019d01af-cb3c-75fa-a60c-80a74b6eb9ef.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://eosfitness.com/gym/salt-lake-city-s-700-e-500-s/?utm_source=local&utm_medium=organic&utm_campaign=evergreen_gmb",
      "poi_directions_map_url": "https://maps.google.com/?cid=14535606599363472597&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "es-fitness",
      "poi_latitude": "40.7578479",
      "poi_longitude": "-111.8703661",
      "poi_miles_from_property": "2.9",
      "poi_walking_minutes": "1 hour 7 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 801-850-9810",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167070/019d01af-796e-7515-b2be-b8f0e8c305a7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01af-796e-7515-b2be-b8f0e8c305a7",
        "storage_key": "property/6767906449167070/019d01af-796e-7515-b2be-b8f0e8c305a7.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ625mDen1UocR1SzibTDZuMk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_6fb123da-34a8-4162-8d86-fad792cfc49f",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167070",
      "source": "custom",
      "poi_name": "MedVet Salt Lake City",
      "poi_type": "Health and Wellness",
      "poi_address": "331 W Bearcat Dr, Salt Lake City, UT 84115, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167070/019d01af-cf5b-7008-a5f3-e3a4dc813ad5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01af-cf5b-7008-a5f3-e3a4dc813ad5",
        "storage_key": "property/6767906449167070/019d01af-cf5b-7008-a5f3-e3a4dc813ad5.webp",
        "width": 1024,
        "height": 1025
      },
      "poi_business_url": "https://www.medvet.com/location/salt-lake-city/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9152040258644601329&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "medvet-salt-lake-city",
      "poi_latitude": "40.7191329",
      "poi_longitude": "-111.9001756",
      "poi_miles_from_property": "4.1",
      "poi_walking_minutes": "1 hour 31 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 385-341-4444",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167070/019d01af-796e-7515-b2be-b8f0e8c305a7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01af-796e-7515-b2be-b8f0e8c305a7",
        "storage_key": "property/6767906449167070/019d01af-796e-7515-b2be-b8f0e8c305a7.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJtQbBfbKLUocR8emVKiCUAn8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "veterinary_care"
    },
    {
      "id": "custom_c1605c49-e592-4ccf-82a0-fd5b6c4ba23a",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167070",
      "source": "custom",
      "poi_name": "Planet Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "175 E 400 S Ste 100, Salt Lake City, UT 84111, USA",
      "poi_short_description": "Members-only gym chain providing equipment, plus tanning beds, and massage beds.",
      "poi_long_description": "Some gym goers say this gym offers a wide variety of equipment, including cardio machines and free weights, and is clean with friendly staff.\n\nOther reviews mention the gym can be crowded and some equipment can be out of order.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167070/019d01af-434f-737e-9964-6bd43a570649.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01af-434f-737e-9964-6bd43a570649",
        "storage_key": "property/6767906449167070/019d01af-434f-737e-9964-6bd43a570649.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.planetfitness.com/gyms/salt-lake-city-ut?utm_medium=organic&utm_source=extnet",
      "poi_directions_map_url": "https://maps.google.com/?cid=18208306272100797670&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "planet-fitness",
      "poi_latitude": "40.7610034",
      "poi_longitude": "-111.8859766",
      "poi_miles_from_property": "1.9",
      "poi_walking_minutes": "43 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 801-521-9400",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167070/019d01af-796e-7515-b2be-b8f0e8c305a7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01af-796e-7515-b2be-b8f0e8c305a7",
        "storage_key": "property/6767906449167070/019d01af-796e-7515-b2be-b8f0e8c305a7.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ6Up5yBH1UocR5swVLhXmsPw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_98b36348-d6db-492c-ba54-7f5851709f23",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167070",
      "source": "custom",
      "poi_name": "VASA Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "1172 Brickyard Rd, Salt Lake City, UT 84106, USA",
      "poi_short_description": "Friendly-staffed fitness center offering plentiful weights and cardio machines, HIIT classes and personal training.",
      "poi_long_description": "People say this gym offers a wide variety of equipment, fitness classes, and personal training options, and provides a clean and well-maintained facility.\n\nOther reviews mention the gym can be crowded and the equipment can be occupied.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167070/019d01af-cff0-756d-a213-67d7117ee819.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01af-cff0-756d-a213-67d7117ee819",
        "storage_key": "property/6767906449167070/019d01af-cff0-756d-a213-67d7117ee819.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://vasafitness.com/locations/ut/brickyard/?utm_medium=organic&utm_source=GMBlisting&utm_campaign=maps",
      "poi_directions_map_url": "https://maps.google.com/?cid=8228090890031575762&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "vasa-fitness",
      "poi_latitude": "40.7011744",
      "poi_longitude": "-111.8583855",
      "poi_miles_from_property": "7.4",
      "poi_walking_minutes": "2 hours 48 mins",
      "poi_biking_minutes": "43 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 801-484-8786",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167070/019d01af-796e-7515-b2be-b8f0e8c305a7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01af-796e-7515-b2be-b8f0e8c305a7",
        "storage_key": "property/6767906449167070/019d01af-796e-7515-b2be-b8f0e8c305a7.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ3yH-3X-KUocR0rL19xENMHI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_a4f784f1-1997-480c-8600-da1122c120e9",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167070",
      "source": "custom",
      "poi_name": "Planet Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "635 E 3300 S, Salt Lake City, UT 84106, USA",
      "poi_short_description": "Gym featuring cardio equipment and a fitness center, along with massage chairs, tanning and showers.",
      "poi_long_description": "People say this gym is clean and has friendly staff, and they appreciate the great hours. They also highlight the well-maintained equipment.\n\nSome reviews mention the equipment can be limited in variety.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167070/019d01af-434f-737e-9964-6bd43a570649.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01af-434f-737e-9964-6bd43a570649",
        "storage_key": "property/6767906449167070/019d01af-434f-737e-9964-6bd43a570649.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.planetfitness.com/gyms/south-salt-lake-city-ut?utm_medium=organic&utm_source=extnet",
      "poi_directions_map_url": "https://maps.google.com/?cid=889767685976005286&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "planet-fitness",
      "poi_latitude": "40.7006692",
      "poi_longitude": "-111.8733713",
      "poi_miles_from_property": "6.8",
      "poi_walking_minutes": "2 hours 33 mins",
      "poi_biking_minutes": "38 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 801-467-6711",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167070/019d01af-796e-7515-b2be-b8f0e8c305a7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01af-796e-7515-b2be-b8f0e8c305a7",
        "storage_key": "property/6767906449167070/019d01af-796e-7515-b2be-b8f0e8c305a7.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJsQyfLglhUocRppo4B_8WWQw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_14b16f55-f4b1-4f19-93bd-fa98814b4b36",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167070",
      "source": "custom",
      "poi_name": "Salt Lake Tennis & Health Club",
      "poi_type": "Health and Wellness",
      "poi_address": "2471 S 1700 E, Salt Lake City, UT 84106, USA",
      "poi_short_description": "Family-friendly destination offering tennis, fitness and wellness programs since 1912.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167070/019d01af-d06f-71cc-98ed-8fcab30e893f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01af-d06f-71cc-98ed-8fcab30e893f",
        "storage_key": "property/6767906449167070/019d01af-d06f-71cc-98ed-8fcab30e893f.webp",
        "width": 640,
        "height": 480
      },
      "poi_business_url": "https://saltlaketennisandhealth.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5105176662547665736&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "salt-lake-tennis--health-club",
      "poi_latitude": "40.7175895",
      "poi_longitude": "-111.840137",
      "poi_miles_from_property": "7",
      "poi_walking_minutes": "2 hours 40 mins",
      "poi_biking_minutes": "44 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 801-487-3206",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167070/019d01af-796e-7515-b2be-b8f0e8c305a7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01af-796e-7515-b2be-b8f0e8c305a7",
        "storage_key": "property/6767906449167070/019d01af-796e-7515-b2be-b8f0e8c305a7.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJGzsq1TtgUocRSJPETiA72UY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_20fe667f-caaf-45ed-86d6-a698311adc9e",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167070",
      "source": "custom",
      "poi_name": "Planet Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "3749 S Constitution Blvd, West Valley City, UT 84119, USA",
      "poi_short_description": "Gym offering workout equipment, tanning beds and massage chairs, plus free weights.",
      "poi_long_description": "People say this gym offers a wide variety of equipment and workout areas, and is clean and well-maintained. They also highlight the friendly and helpful staff, and the spacious layout that prevents overcrowding.\n\nOther reviews mention the equipment can be broken.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167070/019d01af-434f-737e-9964-6bd43a570649.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01af-434f-737e-9964-6bd43a570649",
        "storage_key": "property/6767906449167070/019d01af-434f-737e-9964-6bd43a570649.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.planetfitness.com/gyms/west-valley-city-ut?utm_medium=organic&utm_source=extnet",
      "poi_directions_map_url": "https://maps.google.com/?cid=12564769528528778260&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "planet-fitness",
      "poi_latitude": "40.6907568",
      "poi_longitude": "-111.9569821",
      "poi_miles_from_property": "7.8",
      "poi_walking_minutes": "2 hours 53 mins",
      "poi_biking_minutes": "48 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 801-462-2020",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167070/019d01af-796e-7515-b2be-b8f0e8c305a7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01af-796e-7515-b2be-b8f0e8c305a7",
        "storage_key": "property/6767906449167070/019d01af-796e-7515-b2be-b8f0e8c305a7.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJN6DFJneNUocRFDScsFAHX64",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_5491af09-3479-4a2e-8076-fdff2ed50847",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167070",
      "source": "custom",
      "poi_name": "All Season Nails",
      "poi_type": "Health and Wellness",
      "poi_address": "1850 S 300 W suite b, Salt Lake City, UT 84115, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167070/019d01af-d3e4-74b5-a5cb-eca76a258fd7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01af-d3e4-74b5-a5cb-eca76a258fd7",
        "storage_key": "property/6767906449167070/019d01af-d3e4-74b5-a5cb-eca76a258fd7.webp",
        "width": 1080,
        "height": 1080
      },
      "poi_business_url": "https://allseasonnailssaltlakecity.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=18350272123930257472&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "all-season-nails",
      "poi_latitude": "40.7295549",
      "poi_longitude": "-111.9012471",
      "poi_miles_from_property": "3.3",
      "poi_walking_minutes": "1 hour 14 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 385-522-2378",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167070/019d01af-796e-7515-b2be-b8f0e8c305a7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01af-796e-7515-b2be-b8f0e8c305a7",
        "storage_key": "property/6767906449167070/019d01af-796e-7515-b2be-b8f0e8c305a7.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJpWvM2MOLUocRQKid1kVDqf4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "nail_salon"
    },
    {
      "id": "custom_09c520ae-2f66-4ae3-b175-64000b99f81d",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167070",
      "source": "custom",
      "poi_name": "CorePower Yoga - Highlands SLC",
      "poi_type": "Health and Wellness",
      "poi_address": "3142 Highland Dr Suite A6, Millcreek, UT 84106, USA",
      "poi_short_description": "",
      "poi_long_description": "People say this yoga studio offers challenging and restorative classes, including Yoga Sculpt. They highlight the welcoming and supportive community, and the unique teaching styles of the instructors. They also like the clean studio and the professional and friendly staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167070/019d01af-d468-704b-9116-794e90e82848.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01af-d468-704b-9116-794e90e82848",
        "storage_key": "property/6767906449167070/019d01af-d468-704b-9116-794e90e82848.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.corepoweryoga.com/yoga-studios/ut/salt-lake-city/highlands-slc",
      "poi_directions_map_url": "https://maps.google.com/?cid=4132913013953877687&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "corepower-yoga---highlands-slc",
      "poi_latitude": "40.702428",
      "poi_longitude": "-111.85247",
      "poi_miles_from_property": "7.3",
      "poi_walking_minutes": "2 hours 48 mins",
      "poi_biking_minutes": "45 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 801-290-3308",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167070/019d01af-7952-775f-8ef8-adb49ef68770.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01af-7952-775f-8ef8-adb49ef68770",
        "storage_key": "property/6767906449167070/019d01af-7952-775f-8ef8-adb49ef68770.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJWeZUt9RhUocRt1ZPNH0OWzk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "yoga_studio"
    },
    {
      "id": "custom_2bd42051-ce4c-45ed-934a-9266f6673b3a",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167070",
      "source": "custom",
      "poi_name": "Krishna Temple Salt Lake City",
      "poi_type": "Health and Wellness",
      "poi_address": "965 E 3370 S, Millcreek, UT 84106, USA",
      "poi_short_description": "Yoga classes for all skill levels offered in a serene space within a temple with a gift shop.",
      "poi_long_description": "People say this yoga studio offers aarti every Saturday followed by dinner. They highlight the welcoming and kind atmosphere. They also like the devotional bhajans.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167070/019d01af-d5ed-721d-848e-ac4fb14a26dd.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01af-d5ed-721d-848e-ac4fb14a26dd",
        "storage_key": "property/6767906449167070/019d01af-d5ed-721d-848e-ac4fb14a26dd.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.utahkrishnas.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15578809990885540784&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "krishna-temple-salt-lake-city",
      "poi_latitude": "40.6987352",
      "poi_longitude": "-111.8638672",
      "poi_miles_from_property": "7.3",
      "poi_walking_minutes": "2 hours 46 mins",
      "poi_biking_minutes": "42 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 385-528-7107",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167070/019d01af-7952-775f-8ef8-adb49ef68770.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01af-7952-775f-8ef8-adb49ef68770",
        "storage_key": "property/6767906449167070/019d01af-7952-775f-8ef8-adb49ef68770.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ48kU1n2KUocRsAMKiiUNM9g",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "yoga_studio"
    },
    {
      "id": "custom_c0a64772-64d6-4632-97ad-2724ec525094",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167070",
      "source": "custom",
      "poi_name": "University of Utah Hospital",
      "poi_type": "Health and Wellness",
      "poi_address": "50 Medical Dr N, Salt Lake City, UT 84132, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167070/019d01af-3efb-7438-8869-a1fccdc887ff.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01af-3efb-7438-8869-a1fccdc887ff",
        "storage_key": "property/6767906449167070/019d01af-3efb-7438-8869-a1fccdc887ff.webp",
        "width": 1179,
        "height": 769
      },
      "poi_business_url": "https://healthcare.utah.edu/hospital/?utm_source=google&utm_medium=yext",
      "poi_directions_map_url": "https://maps.google.com/?cid=5918513551681049251&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "university-of-utah-hospital",
      "poi_latitude": "40.7714806",
      "poi_longitude": "-111.8366141",
      "poi_miles_from_property": "4",
      "poi_walking_minutes": "1 hour 41 mins",
      "poi_biking_minutes": "41 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 801-581-2121",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167070/019d01af-7dd0-70ec-80fb-8fa67b03d80b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01af-7dd0-70ec-80fb-8fa67b03d80b",
        "storage_key": "property/6767906449167070/019d01af-7dd0-70ec-80fb-8fa67b03d80b.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJXQMMEJdfUocRo9JItrfIIlI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "general_hospital"
    },
    {
      "id": "custom_744deb29-995b-4229-9bd8-8b94ed5408eb",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167070",
      "source": "custom",
      "poi_name": "Intermountain Health LDS Hospital",
      "poi_type": "Health and Wellness",
      "poi_address": "8th Ave, C St E, Salt Lake City, UT 84143, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167070/019d01af-d8ae-74fc-af08-72583affd192.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01af-d8ae-74fc-af08-72583affd192",
        "storage_key": "property/6767906449167070/019d01af-d8ae-74fc-af08-72583affd192.webp",
        "width": 1080,
        "height": 608
      },
      "poi_business_url": "https://intermountainhealthcare.org/locations/lds-hospital",
      "poi_directions_map_url": "https://maps.google.com/?cid=2659205804862327663&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "intermountain-health-lds-hospital",
      "poi_latitude": "40.7784879",
      "poi_longitude": "-111.8803369",
      "poi_miles_from_property": "2",
      "poi_walking_minutes": "51 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 801-408-1100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167070/019d01af-7dd0-70ec-80fb-8fa67b03d80b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01af-7dd0-70ec-80fb-8fa67b03d80b",
        "storage_key": "property/6767906449167070/019d01af-7dd0-70ec-80fb-8fa67b03d80b.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJ14_kWJ_1UocRb8t5J5dl5yQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_20614688-341d-4ba9-8015-7d270a2b6f81",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167070",
      "source": "custom",
      "poi_name": "Liberty Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "600 Harvey Milk Blvd, Salt Lake City, UT 84105, USA",
      "poi_short_description": "Home to an aviary & museum, this serene landmark features a lake with ducks & paddle-boat rentals.",
      "poi_long_description": "People say this park offers a variety of activities, including an aviary, paddle boats, a Ferris wheel, and a carousel. They highlight the peaceful and relaxing vibe, and the beautiful views and walking paths. They also like the shade, the pond with ducks and geese, and the drum circle. ",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167070/019d01af-5757-7109-8abb-eeb113801148.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01af-5757-7109-8abb-eeb113801148",
        "storage_key": "property/6767906449167070/019d01af-5757-7109-8abb-eeb113801148.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.slc.gov/parks/parks-division/liberty-park/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3840677276212609488&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "liberty-park",
      "poi_latitude": "40.7453368",
      "poi_longitude": "-111.8740916",
      "poi_miles_from_property": "3.6",
      "poi_walking_minutes": "1 hour 21 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 801-972-7800",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167070/019d01af-7dc4-7711-aef5-a945c17fb3b7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01af-7dc4-7711-aef5-a945c17fb3b7",
        "storage_key": "property/6767906449167070/019d01af-7dc4-7711-aef5-a945c17fb3b7.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJZy8zJUT1UocR0EGRSaLTTDU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_33eccc7a-7d7d-4d19-8e03-956b665973ad",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167070",
      "source": "custom",
      "poi_name": "Sugar House Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "1330 2100 S, Salt Lake City, UT 84106, USA",
      "poi_short_description": "This sprawling green space with a pond lures locals for long walks, bike rides, basketball & soccer.",
      "poi_long_description": "People say this park offers a pond, walking trails, playgrounds, sports facilities, and pavilions. They highlight the beautiful scenery, clean environment, and ample parking. They also like the variety of activities, including cycling, jogging, and field sports.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167070/019d01af-d9ef-7682-8879-8ba74a464beb.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01af-d9ef-7682-8879-8ba74a464beb",
        "storage_key": "property/6767906449167070/019d01af-d9ef-7682-8879-8ba74a464beb.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.sugarhousepark.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9609012369130441100&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "sugar-house-park",
      "poi_latitude": "40.723877",
      "poi_longitude": "-111.8493998",
      "poi_miles_from_property": "6.3",
      "poi_walking_minutes": "2 hours 25 mins",
      "poi_biking_minutes": "40 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 385-468-7275",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167070/019d01af-7dc4-7711-aef5-a945c17fb3b7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01af-7dc4-7711-aef5-a945c17fb3b7",
        "storage_key": "property/6767906449167070/019d01af-7dc4-7711-aef5-a945c17fb3b7.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJv2EFiCJgUocRjMlayNYRWoU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_9300686a-2231-4403-8058-67ac3c9bb228",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167070",
      "source": "custom",
      "poi_name": "Red Butte Garden and Arboretum",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "300 Wakara Way, Salt Lake City, UT 84108, USA",
      "poi_short_description": "University of Utah's botanical garden features nature trails, workshops & an outdoor concert series.",
      "poi_long_description": "People say this botanical garden offers a wide variety of plants, flowers, and themed gardens, including a rose garden, fragrance garden, and medicinal garden. They highlight the beautiful, peaceful, and relaxing atmosphere, as well as the well-maintained grounds, hiking trails, and water features. They also like the friendly and helpful staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167070/019d01af-dbc0-77ec-81be-9e49309798e4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01af-dbc0-77ec-81be-9e49309798e4",
        "storage_key": "property/6767906449167070/019d01af-dbc0-77ec-81be-9e49309798e4.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.redbuttegarden.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16232989996537460657&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "red-butte-garden-and-arboretum",
      "poi_latitude": "40.7655152",
      "poi_longitude": "-111.8236336",
      "poi_miles_from_property": "5",
      "poi_walking_minutes": "2 hours 6 mins",
      "poi_biking_minutes": "48 mins",
      "poi_driving_minutes": "19 mins",
      "poi_business_phone": "+1 801-585-0556",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167070/019d01af-796e-7515-b2be-b8f0e8c305a7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01af-796e-7515-b2be-b8f0e8c305a7",
        "storage_key": "property/6767906449167070/019d01af-796e-7515-b2be-b8f0e8c305a7.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ3XwuVcJfUocRsbcVUmUqR-E",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "botanical_garden"
    },
    {
      "id": "custom_45bfec09-5270-46d8-a783-eacb2f0396ae",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167070",
      "source": "custom",
      "poi_name": "This Is The Place Heritage Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "2601 Sunnyside Ave S, Salt Lake City, UT 84108, USA",
      "poi_short_description": "Living-history park featuring Mormon monument, train rides, petting zoo & Native American village.",
      "poi_long_description": "People say this state park offers a variety of activities, including pony rides, a train ride, and a pioneer village with historical buildings. They highlight the beautiful grounds, the educational experience, and the fun activities for families. They also like the friendly and knowledgeable staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167070/019d01af-db3a-77b5-bf95-b41144dcbd67.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01af-db3a-77b5-bf95-b41144dcbd67",
        "storage_key": "property/6767906449167070/019d01af-db3a-77b5-bf95-b41144dcbd67.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.thisistheplace.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16090868871749510884&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "this-is-the-place-heritage-park",
      "poi_latitude": "40.7520271",
      "poi_longitude": "-111.8162017",
      "poi_miles_from_property": "6",
      "poi_walking_minutes": "2 hours 24 mins",
      "poi_biking_minutes": "48 mins",
      "poi_driving_minutes": "19 mins",
      "poi_business_phone": "+1 801-582-1847",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167070/019d01af-7dc4-7711-aef5-a945c17fb3b7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01af-7dc4-7711-aef5-a945c17fb3b7",
        "storage_key": "property/6767906449167070/019d01af-7dc4-7711-aef5-a945c17fb3b7.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJQxRE0iteUocR5CYFXPw_Tt8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "state_park"
    },
    {
      "id": "custom_a84f6af2-dd90-41f0-89d5-368b7150b258",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167070",
      "source": "custom",
      "poi_name": "Capitol Hill, Salt Lake City, UT",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "Utah State Capitol, Salt Lake City, UT 84103, USA",
      "poi_short_description": "",
      "poi_long_description": "People say this park offers beautiful views of the city and surrounding mountains, and the Capitol building is impressive and grand. They highlight the well-maintained grounds, monuments, and displays, and the welcoming and inviting atmosphere. They also like the free parking and the opportunity to explore the building's interior.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167070/019d01af-dd36-729f-bc88-cae78be7a3f1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01af-dd36-729f-bc88-cae78be7a3f1",
        "storage_key": "property/6767906449167070/019d01af-dd36-729f-bc88-cae78be7a3f1.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://utahstatecapitol.utah.gov/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9599708513414675422&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "capitol-hill-salt-lake-city-ut",
      "poi_latitude": "40.77731259999999",
      "poi_longitude": "-111.8878794",
      "poi_miles_from_property": "1.6",
      "poi_walking_minutes": "40 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167070/019d01af-7dc4-7711-aef5-a945c17fb3b7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01af-7dc4-7711-aef5-a945c17fb3b7",
        "storage_key": "property/6767906449167070/019d01af-7dc4-7711-aef5-a945c17fb3b7.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJN-M3sSH1UocR3vtfEQgEOYU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_3d2de86f-caf9-4818-8088-bb5eabacdb2b",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167070",
      "source": "custom",
      "poi_name": "Salt Lake City International Airport",
      "poi_type": "Transportation & Transit",
      "poi_address": "3920 W Terminal Dr, Salt Lake City, UT 84122, USA",
      "poi_short_description": "Airport featuring a number of restaurants plus free WiFi & lots of art displays.",
      "poi_long_description": "People say this airport offers a wide variety of food options and shops. They also highlight the clean, modern facilities, the efficient security process, and the friendly staff.\n\nOther reviews mention the walk to some gates can be long.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167070/019d01af-6432-72dd-9305-d4955d8ad23a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01af-6432-72dd-9305-d4955d8ad23a",
        "storage_key": "property/6767906449167070/019d01af-6432-72dd-9305-d4955d8ad23a.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://slcairport.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8007192497092118553&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "salt-lake-city-international-airport",
      "poi_latitude": "40.7903145",
      "poi_longitude": "-111.9771441",
      "poi_miles_from_property": "8.9",
      "poi_walking_minutes": "3 hours 14 mins",
      "poi_biking_minutes": "49 mins",
      "poi_driving_minutes": "20 mins",
      "poi_business_phone": "+1 801-575-2400",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167070/019d01af-82ac-7527-8ec5-84f53f07ae80.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01af-82ac-7527-8ec5-84f53f07ae80",
        "storage_key": "property/6767906449167070/019d01af-82ac-7527-8ec5-84f53f07ae80.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJ6fTXZ4vzUocRGUhZ9SZDH28",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "international_airport"
    },
    {
      "id": "custom_7e963543-47eb-4c8b-a6b6-99eb277a57dc",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167070",
      "source": "custom",
      "poi_name": "Salt Lake Central Station",
      "poi_type": "Transportation & Transit",
      "poi_address": "340 S 600 W, Salt Lake City, UT 84101, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167070/019d01af-e207-757a-834d-f082a69f1c3c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01af-e207-757a-834d-f082a69f1c3c",
        "storage_key": "property/6767906449167070/019d01af-e207-757a-834d-f082a69f1c3c.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.rideuta.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4621207170146558561&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "salt-lake-central-station",
      "poi_latitude": "40.7624606",
      "poi_longitude": "-111.9090351",
      "poi_miles_from_property": "0.7",
      "poi_walking_minutes": "14 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167070/019d01af-f6a0-76a9-bbba-88fc275ab782.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01af-f6a0-76a9-bbba-88fc275ab782",
        "storage_key": "property/6767906449167070/019d01af-f6a0-76a9-bbba-88fc275ab782.webp",
        "width": 161,
        "height": 192
      },
      "poi_google_place_id": "ChIJESbRafz0UocRYeIS4m_TIUA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "train_station"
    },
    {
      "id": "custom_47b34d43-c2eb-4be1-a8e3-12974304cee5",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167070",
      "source": "custom",
      "poi_name": "North Temple Station",
      "poi_type": "Transportation & Transit",
      "poi_address": "Salt Lake City, UT 84103, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167070/019d01af-e1ea-700d-b3ec-96a97984587d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01af-e1ea-700d-b3ec-96a97984587d",
        "storage_key": "property/6767906449167070/019d01af-e1ea-700d-b3ec-96a97984587d.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=17090140258902178030&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "north-temple-station",
      "poi_latitude": "40.7727569",
      "poi_longitude": "-111.905134",
      "poi_miles_from_property": "0.4",
      "poi_walking_minutes": "9 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167070/019d01af-f6a0-76a9-bbba-88fc275ab782.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01af-f6a0-76a9-bbba-88fc275ab782",
        "storage_key": "property/6767906449167070/019d01af-f6a0-76a9-bbba-88fc275ab782.webp",
        "width": 161,
        "height": 192
      },
      "poi_google_place_id": "ChIJTQo10FT0UocR7nh3nQRgLO0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "train_station"
    },
    {
      "id": "custom_2ed229a0-839e-4062-b188-d10ff16e7acd",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167070",
      "source": "custom",
      "poi_name": "Millcreek Station",
      "poi_type": "Transportation & Transit",
      "poi_address": "210 W 3300 S, South Salt Lake, UT 84115, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167070/019d01af-e302-71a2-8dfd-19d48f2ab395.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01af-e302-71a2-8dfd-19d48f2ab395",
        "storage_key": "property/6767906449167070/019d01af-e302-71a2-8dfd-19d48f2ab395.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.rideuta.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11472917608681391745&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "millcreek-station",
      "poi_latitude": "40.7009164",
      "poi_longitude": "-111.8969535",
      "poi_miles_from_property": "5.6",
      "poi_walking_minutes": "2 hours 5 mins",
      "poi_biking_minutes": "31 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 801-743-3882",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167070/019d01af-796e-7515-b2be-b8f0e8c305a7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01af-796e-7515-b2be-b8f0e8c305a7",
        "storage_key": "property/6767906449167070/019d01af-796e-7515-b2be-b8f0e8c305a7.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJyf9doPuKUocRgUbHasf9N58",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "light_rail_station"
    },
    {
      "id": "custom_a1a19bb3-e744-4aaf-ba99-cc6ee76d2be7",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167070",
      "source": "custom",
      "poi_name": "Airport Station",
      "poi_type": "Transportation & Transit",
      "poi_address": "Q2M8+MF, Salt Lake City, UT 84122, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167070/019d01af-e524-7556-b794-0183826cac57.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01af-e524-7556-b794-0183826cac57",
        "storage_key": "property/6767906449167070/019d01af-e524-7556-b794-0183826cac57.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://rideuta.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11284631330085558998&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "airport-station",
      "poi_latitude": "40.78426700000001",
      "poi_longitude": "-111.983364",
      "poi_miles_from_property": "5.1",
      "poi_walking_minutes": "1 hour 52 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167070/019d01af-796e-7515-b2be-b8f0e8c305a7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01af-796e-7515-b2be-b8f0e8c305a7",
        "storage_key": "property/6767906449167070/019d01af-796e-7515-b2be-b8f0e8c305a7.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJcTvSzdzzUocR1lr--mcQm5w",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "light_rail_station"
    },
    {
      "id": "custom_dfaf2448-3b0d-45a4-b78a-2d03c6effa87",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167070",
      "source": "custom",
      "poi_name": "L3Harris Technologies: Communication Systems-West",
      "poi_type": "Major Employers & Offices",
      "poi_address": "640 N 2200 W, Salt Lake City, UT 84116, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167070/019d01af-ec82-771a-8987-7aaccb2ad6b2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01af-ec82-771a-8987-7aaccb2ad6b2",
        "storage_key": "property/6767906449167070/019d01af-ec82-771a-8987-7aaccb2ad6b2.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://l3harris.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=18300702297262212660&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "l3harris-technologies-communication-systems-west",
      "poi_latitude": "40.7835508",
      "poi_longitude": "-111.9523593",
      "poi_miles_from_property": "3.2",
      "poi_walking_minutes": "1 hour 10 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 801-594-2000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167070/019d01af-796e-7515-b2be-b8f0e8c305a7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01af-796e-7515-b2be-b8f0e8c305a7",
        "storage_key": "property/6767906449167070/019d01af-796e-7515-b2be-b8f0e8c305a7.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJpUnzcgr0UocRNEZ9MMcn-f0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_97682db9-5698-4d2a-a475-e3fcbf77c10b",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167070",
      "source": "custom",
      "poi_name": "Varex Imaging Visitor Entrance",
      "poi_type": "Major Employers & Offices",
      "poi_address": "1678 Pioneer Rd, Salt Lake City, UT 84104, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167070/019d01af-e7f2-72ba-a12f-a13b1449f69d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01af-e7f2-72ba-a12f-a13b1449f69d",
        "storage_key": "property/6767906449167070/019d01af-e7f2-72ba-a12f-a13b1449f69d.webp",
        "width": 909,
        "height": 634
      },
      "poi_business_url": "http://www.vareximaging.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2741201802850912740&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "varex-imaging-visitor-entrance",
      "poi_latitude": "40.7332053",
      "poi_longitude": "-111.9591313",
      "poi_miles_from_property": "5.2",
      "poi_walking_minutes": "1 hour 54 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 801-972-5000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167070/019d01af-796e-7515-b2be-b8f0e8c305a7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01af-796e-7515-b2be-b8f0e8c305a7",
        "storage_key": "property/6767906449167070/019d01af-796e-7515-b2be-b8f0e8c305a7.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJaRP7vFvzUocR5MmWJIS0CiY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_886857da-f162-4789-9b2e-436fbf87c54e",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167070",
      "source": "custom",
      "poi_name": "bioMérieux",
      "poi_type": "Major Employers & Offices",
      "poi_address": "1201 S 4800 W, Salt Lake City, UT 84104, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167070/019d01af-e98d-7207-b6d7-06f0a07d1ab9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01af-e98d-7207-b6d7-06f0a07d1ab9",
        "storage_key": "property/6767906449167070/019d01af-e98d-7207-b6d7-06f0a07d1ab9.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.biomerieux.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7144533276497633756&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "biomrieux",
      "poi_latitude": "40.7445068",
      "poi_longitude": "-112.0047378",
      "poi_miles_from_property": "9",
      "poi_walking_minutes": "3 hours 16 mins",
      "poi_biking_minutes": "36 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 801-736-6354",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167070/019d01af-796e-7515-b2be-b8f0e8c305a7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01af-796e-7515-b2be-b8f0e8c305a7",
        "storage_key": "property/6767906449167070/019d01af-796e-7515-b2be-b8f0e8c305a7.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJm3Bb8XfzUocR3GGZXyl7JmM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_42862ed4-1baf-4b81-82dd-53a672c3fb71",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167070",
      "source": "custom",
      "poi_name": "Salt Lake City and County Building",
      "poi_type": "Major Employers & Offices",
      "poi_address": "451 S State St, Salt Lake City, UT 84111, USA",
      "poi_short_description": "Victorian-era city hall noted for its iconic 256-foot clock tower & carved gray sandstone facade.",
      "poi_long_description": "Victorian-era city hall noted for its iconic 256-foot clock tower & carved gray sandstone facade.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167070/019d01af-685c-7023-b9df-40aba49d63df.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01af-685c-7023-b9df-40aba49d63df",
        "storage_key": "property/6767906449167070/019d01af-685c-7023-b9df-40aba49d63df.webp",
        "width": 1280,
        "height": 875
      },
      "poi_business_url": "http://www.slc.gov/",
      "poi_directions_map_url": "https://maps.google.com/?cid=726748788876054070&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "salt-lake-city-and-county-building",
      "poi_latitude": "40.75952720000001",
      "poi_longitude": "-111.8870898",
      "poi_miles_from_property": "1.9",
      "poi_walking_minutes": "44 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 801-535-7704",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167070/019d01af-7931-7359-96af-9afc31e7da99.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01af-7931-7359-96af-9afc31e7da99",
        "storage_key": "property/6767906449167070/019d01af-7931-7359-96af-9afc31e7da99.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJfWXpWBH1UocRNg7nSSzuFQo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "city_hall"
    },
    {
      "id": "custom_aa60a0c7-7974-4274-b6ab-ee06e4ac0678",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167070",
      "source": "custom",
      "poi_name": "INDUSTRY SLC",
      "poi_type": "Major Employers & Offices",
      "poi_address": "650 S 500 W, Salt Lake City, UT 84101, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167070/019d01af-ed50-76ca-98fe-d0b01496819f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01af-ed50-76ca-98fe-d0b01496819f",
        "storage_key": "property/6767906449167070/019d01af-ed50-76ca-98fe-d0b01496819f.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.industryoffice.com/slc",
      "poi_directions_map_url": "https://maps.google.com/?cid=318628017020505743&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "industry-slc",
      "poi_latitude": "40.7551242",
      "poi_longitude": "-111.9057491",
      "poi_miles_from_property": "1.3",
      "poi_walking_minutes": "28 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167070/019d01af-796e-7515-b2be-b8f0e8c305a7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01af-796e-7515-b2be-b8f0e8c305a7",
        "storage_key": "property/6767906449167070/019d01af-796e-7515-b2be-b8f0e8c305a7.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJvX3Xt0v1UocRj47-SX7-awQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    }
  ],
  "office_hours": [
    {
      "id": "ec_4d310fb98eabdd70ea80c165",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167070",
      "day": "MON",
      "open_time": "10:00",
      "close_time": "17:00"
    },
    {
      "id": "ec_27cd58a1477b3fc3ba2aec60",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167070",
      "day": "TUE",
      "open_time": "10:00",
      "close_time": "17:00"
    },
    {
      "id": "ec_90d28452b05348a9d70ca829",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167070",
      "day": "THU",
      "open_time": "10:00",
      "close_time": "17:00"
    },
    {
      "id": "ec_e233f9db2f967de2944ed8af",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167070",
      "day": "FRI",
      "open_time": "10:00",
      "close_time": "17:00"
    },
    {
      "id": "ec_f3537ccc88caa5152d4e2a19",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167070",
      "day": "WED",
      "open_time": "10:00",
      "close_time": "17:00"
    }
  ],
  "reviews": [
    {
      "id": "custom_a0eb27fe-5535-4f3f-bef8-6fd3797c7537",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167070",
      "rating": "5.0",
      "name": "mufiz shaikh",
      "text": "I've had a truly positive experience during my 3 year+ stay at this apartment. The staff's responsiveness and helpfulness have been outstanding, ensuring that every request was addressed in a timely manner. My apartment was always fully functional, and I appreciated the consistent cleanliness of the hallways and passages in my floor. I do want to note that early in my stay, there was a noticeable presence of homeless individuals near the elevator. However, this issue has since subsided and is no longer a problem. While no apartment is entirely without its quirks, any minor issues here were easily manageable and didn't detract from my overall satisfaction. I extend my sincere gratitude to Bea Cervantes, the apartment manager. Her exceptional assistance with my lease termination, necessitated by a visa situation, was instrumental in making my departure remarkably pleasant and stress-free. The new management deserves high praise for their excellent service.",
      "date": "2025-07-15",
      "title": ""
    }
  ],
  "virtual_tours": [
    {
      "id": "custom_b6f346c6-57ee-40ed-ba27-178fa5c6860f",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167070",
      "source": "custom",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167070/019d01b0-8534-73e8-b9cd-1fdb4eb3eef6.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": "Community lounge area with sofas, ping pong table, and access to outdoor patio.",
        "public_id": "019d01b0-8534-73e8-b9cd-1fdb4eb3eef6",
        "storage_key": "property/6767906449167070/019d01b0-8534-73e8-b9cd-1fdb4eb3eef6.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "Bridges | Clubhouse | Fitness Center",
      "virtual_tour_type": "Community",
      "virtual_tour_url": "https://my.matterport.com/show/?m=3edZELgcnqn"
    }
  ],
  "faqs": [],
  "fees": [],
  "pet_policies": [],
  "lead_collectors": [
    {
      "lead_collector_id": "019eb963-416d-7701-8812-b14e6069de8e",
      "lead_source": "PROPERTY_WEBSITE",
      "name": "Bridges Apartment Homes Website",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167070"
    }
  ],
  "hyperlocal_queries": [
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167070",
      "source": "generator",
      "page_item_url": "in-unit-laundry-apartments-salt-lake-city",
      "search_query": "in unit laundry apartments Salt Lake City",
      "category": "Amenity",
      "h1_title": "In-Unit Laundry Apartments in Salt Lake City",
      "h2_subtitle": "Discover the convenience of in-unit laundry in our Salt Lake City apartments. Experience modern living with top-notch amenities at Bridges.",
      "page_copy": "Welcome to Bridges, where comfort and convenience coalesce in the heart of Salt Lake City. Our apartments are designed to cater to your modern lifestyle, featuring in-unit laundry facilities that make everyday chores effortless. Nestled in the vibrant Downtown area, Bridges offers a host of amenities, including a kitchen island and breakfast nook, perfect for both entertaining and quiet mornings.\n\nAt Bridges, residents enjoy more than just in-unit laundry. Our community boasts gated access, providing an additional layer of security. Large closets offer ample storage, and with on-site maintenance, you're assured of a hassle-free living experience. Located conveniently near the city's bustling activities, Bridges truly embodies urban living with a touch of tranquility. Choose Bridges for an unparalleled Salt Lake City living experience.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "In-Unit Laundry Apartments in Salt Lake City",
      "seo_description": "Explore in-unit laundry apartments at Bridges, Salt Lake City. Enjoy modern amenities like large closets and kitchen islands in the Downtown area.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167070",
      "source": "generator",
      "page_item_url": "air-conditioned-apartments-near-downtown-slc",
      "search_query": "air conditioned apartments near Downtown Salt Lake City",
      "category": "Amenity",
      "h1_title": "Air Conditioned Apartments Near Downtown SLC",
      "h2_subtitle": "Stay cool with air conditioned apartments near Downtown Salt Lake City. Find your comfort oasis at Bridges, complete with modern features.",
      "page_copy": "Experience cool comfort at Bridges, where air conditioned apartments near Downtown Salt Lake City offer a perfect blend of style and convenience. Located in a vibrant neighborhood, Bridges provides the ideal escape from the city's hustle while keeping you close to the action. Our community is designed with your needs in mind, including spacious living areas and contemporary amenities like a kitchen island and breakfast nook.\n\nBridges isn't just about comfort; it’s about enhancing your lifestyle. Enjoy the peace of mind our gated community provides, along with the convenience of on-site maintenance. Our large closets accommodate all your storage needs, while our thoughtful design ensures each apartment feels like home. For those seeking a cool retreat in Salt Lake City, make Bridges your next destination.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Air Conditioned Apartments Near Downtown SLC",
      "seo_description": "Discover air conditioned apartments at Bridges near Downtown SLC, offering comfort and modern amenities like kitchen islands in a gated community.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167070",
      "source": "generator",
      "page_item_url": "apartments-with-a-pool-salt-lake-county",
      "search_query": "apartments with a pool Salt Lake County",
      "category": "Amenity",
      "h1_title": "Apartments with a Pool in Salt Lake County",
      "h2_subtitle": "Dive into relaxation with our apartments featuring a pool in Salt Lake County. Enjoy exceptional amenities at Bridges.",
      "page_copy": "Bridges offers a refreshing oasis in Salt Lake County with its apartments featuring a pool, perfect for unwinding after a busy day. Located in the Downtown area, our community combines urban living with ample opportunities for relaxation and recreation. Whether you're lounging by the pool or mingling with friends, Bridges ensures a vibrant lifestyle.\n\nBeyond the pool, residents benefit from numerous amenities, including spacious kitchen islands and breakfast nooks, ideal for cooking and dining. Our gated community enhances security, while on-site maintenance guarantees a worry-free living experience. With large closets for storage and an ideal location close to city attractions, Bridges is an excellent choice for those seeking a dynamic yet serene living environment.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments with a Pool in Salt Lake County",
      "seo_description": "Enjoy a pool and top amenities in Salt Lake County at Bridges. Ideal downtown apartments with spacious kitchens and modern comforts.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167070",
      "source": "generator",
      "page_item_url": "fitness-center-apartments-84116",
      "search_query": "fitness center apartments 84116",
      "category": "Amenity",
      "h1_title": "Fitness Center Apartments in 84116",
      "h2_subtitle": "Elevate your lifestyle in our 84116 fitness center apartments. Enjoy a healthy living environment at Bridges, complete with modern amenities.",
      "page_copy": "Located in the 84116 area, Bridges offers residents access to state-of-the-art fitness center apartments tailored for a healthy and active lifestyle. Embrace the convenience of having a fully equipped fitness center just steps from your door, making it easier than ever to keep up with your fitness goals. Situated in vibrant Salt Lake City, our community combines wellness with modern living.\n\nBeyond the fitness offerings, Bridges provides exceptional amenities such as a kitchen island and breakfast nook, creating the perfect setting for both dining and socializing. Our gated community ensures peace of mind, complemented by large closets providing ample storage space. With on-site maintenance, you can enjoy a seamless living experience in the heart of Salt Lake County. Discover the joy of living at Bridges, where fitness and comfort meet.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Fitness Center Apartments in 84116",
      "seo_description": "Discover Bridges in 84116, offering fitness center apartments with modern amenities like gated access and large closets in Salt Lake City.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167070",
      "source": "generator",
      "page_item_url": "spacious-apartments-walk-in-closets-salt-lake-city",
      "search_query": "spacious apartments with walk-in closets in Salt Lake City",
      "category": "Amenity",
      "h1_title": "Spacious Apartments with Walk-In Closets, SLC",
      "h2_subtitle": "Discover spacious apartments with walk-in closets in Salt Lake City at Bridges, where comfort meets style in a prime location.",
      "page_copy": "Welcome to Bridges, your destination for spacious apartments with walk-in closets in Salt Lake City. Situated in the lively Downtown neighborhood, our apartments offer generous living spaces designed to accommodate your lifestyle. Each apartment features expansive rooms and copious storage options, with walk-in closets providing a perfect solution for all your belongings.\n\nBridges isn't just about space; it's about enhancing your living experience with high-end amenities. Our community boasts features like kitchen islands and breakfast nooks, ideal for culinary creations and casual dining. Enjoy the peace of mind provided by our gated community, along with the convenience of on-site maintenance services. Experience modern living with all the benefits of Salt Lake City right at your doorstep.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Spacious Apartments with Walk-In Closets, SLC",
      "seo_description": "Explore spacious SLC apartments with walk-in closets at Bridges, offering modern amenities and prime Downtown living in Salt Lake City.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167070",
      "source": "generator",
      "page_item_url": "one-bedroom-apartments-salt-lake-city",
      "search_query": "one bedroom apartments salt lake city",
      "category": "Floorplan",
      "h1_title": "One Bedroom Apartments in Salt Lake City",
      "h2_subtitle": "Discover ideal one bedroom apartments in Salt Lake City at Bridges. Experience urban living with exceptional amenities and comfort.",
      "page_copy": "At Bridges, we offer an outstanding selection of one bedroom apartments in Salt Lake City designed to cater to modern lifestyles. Located in the dynamic Downtown area, our apartments are perfect for those looking to balance the buzz of city life with a cozy and serene home environment.\n\nEach one bedroom apartment is thoughtfully designed with personalized touches, such as kitchen islands and inviting breakfast nooks that enhance daily living. The community is gated, ensuring safety and peace of mind for residents. With the support of on-site maintenance, any concerns are promptly addressed, while the ample closet space provides room for all your personal effects. Choose Bridges for a one bedroom apartment that elevates urban living.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "One Bedroom Apartments in Salt Lake City",
      "seo_description": "Find perfect one bedroom apartments in Salt Lake City at Bridges, offering stylish designs and prime downtown amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167070",
      "source": "generator",
      "page_item_url": "two-bedroom-apartments-downtown-salt-lake-city",
      "search_query": "two bedroom apartments downtown salt lake city",
      "category": "Floorplan",
      "h1_title": "Two Bedroom Apartments Downtown SLC",
      "h2_subtitle": "Explore two bedroom apartments in downtown Salt Lake City at Bridges, where convenience meets stylish living in an unbeatable location.",
      "page_copy": "Experience the best of urban living with two bedroom apartments in downtown Salt Lake City at Bridges. Our community places you at the heart of the vibrant city life, while offering a peaceful retreat with its well-designed living spaces. Each apartment features two roomy bedrooms, perfect for families or individuals needing extra space.\n\nAt Bridges, enjoy a host of amenities crafted for comfort and ease. From modern kitchen islands ideal for entertaining, to spacious breakfast nooks suited for relaxed mornings, our apartments are designed with you in mind. The gated community provides added security and peace of mind, while the available on-site maintenance ensures a hassle-free living experience. Discover downtown living at its finest, balanced with the comforts of home at Bridges.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Two Bedroom Apartments Downtown SLC",
      "seo_description": "Discover two bedroom apartments in downtown SLC at Bridges, featuring modern designs and prime amenities in a coveted urban location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167070",
      "source": "generator",
      "page_item_url": "three-bedroom-apartments-in-salt-lake-county",
      "search_query": "three bedroom apartments in salt lake county",
      "category": "Floorplan",
      "h1_title": "Three Bedroom Apartments in Salt Lake County",
      "h2_subtitle": "Find spacious three bedroom apartments in Salt Lake County at Bridges, offering ample living areas and top-notch amenities.",
      "page_copy": "Looking for three bedroom apartments in Salt Lake County? Bridges is the perfect choice, offering spacious accommodations that are ideal for families or anyone needing a bit more room. Situated in the vibrant downtown area of Salt Lake City, our community provides easy access to local culture while ensuring all the comforts of home.\n\nOur three bedroom apartments are equipped with features that enhance daily living, from kitchen islands that invite culinary creativity to breakfast nooks perfect for casual dining. The community’s gated security and on-site maintenance services offer additional conveniences and peace of mind. Choose Bridges for a home where spacious living meets a dynamic city vibe, right in the heart of Salt Lake County.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Three Bedroom Apartments in Salt Lake County",
      "seo_description": "Explore spacious three bedroom apartments at Bridges in Salt Lake County, offering top amenities and a vibrant downtown location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    }
  ],
  "custom_fields": [
    {
      "ID": "custom_csm",
      "type": "STRING",
      "value": "bobbi@repli360.com"
    },
    {
      "ID": "custom_pixel_id",
      "type": "STRING",
      "value": "1035508496598043"
    },
    {
      "ID": "custom_repli_id",
      "type": "STRING",
      "value": "11307935174"
    },
    {
      "ID": "custom_text_us_url",
      "type": "STRING",
      "value": "https://popcard.rentcafe.com/TextUsWidget.aspx?dnis=8018509581"
    },
    {
      "ID": "custom_google_gtm_id",
      "type": "STRING",
      "value": "GTM-NMSGFB3F"
    },
    {
      "ID": "custom_rollout_phase",
      "type": "STRING",
      "value": "Phase 5"
    },
    {
      "ID": "custom_rentgrata_token",
      "type": "STRING",
      "value": "a39bf93f-9f0e-49bf-933f-45911274b913"
    },
    {
      "ID": "custom_vibesites_theme",
      "type": "STRING",
      "value": "Vantage"
    },
    {
      "ID": "custom_ads_subscription",
      "type": "STRING",
      "value": "none"
    },
    {
      "ID": "custom_rentcafe_chatbot",
      "type": "STRING",
      "value": "<script type=\"text/javascript\" src=\"//webchat.omni.cafe/conversations/8a497492-95bd-47f6-984c-9e1b13c42df7/app.js?property=8a497492-95bd-47f6-984c-9e1b13c42df7&propertyName=Bridges+Apartment+Homes&channelUuid=c248e3a5-8dac-11ec-afb4-42010aa42b&buttonbgcolor=012345&buttonbgcolor=012345\" defer></script>"
    },
    {
      "ID": "custom_seo_subscription",
      "type": "STRING",
      "value": "none"
    },
    {
      "ID": "custom_social_subscription",
      "type": "STRING",
      "value": "none"
    },
    {
      "ID": "custom_website_subscription",
      "type": "STRING",
      "value": "turnkey"
    },
    {
      "ID": "custom_apartmentsync_javascript_id",
      "type": "STRING",
      "value": "eyJpdiI6IlVCZGdCWVJXRzFMMUVvZmgyQTRmRFE9PSIsInZhbHVlIjoiUlQ2UllxbWdIQkk4QWQ5S3VkNXozQT09IiwibWFjIjoiMDUwZjczZjE0ZGEyZmZjMDI0NzkzYjE5YjU3NGRmM2Y0OWJiMmE2MTU2ZTE1MjJkMmQyYzExZmE4ODEwNTQ4OSJ9"
    }
  ],
  "custom_csm": "bobbi@repli360.com",
  "custom_pixel_id": "1035508496598043",
  "custom_repli_id": "11307935174",
  "custom_text_us_url": "https://popcard.rentcafe.com/TextUsWidget.aspx?dnis=8018509581",
  "custom_google_gtm_id": "GTM-NMSGFB3F",
  "custom_rollout_phase": "Phase 5",
  "custom_rentgrata_token": "a39bf93f-9f0e-49bf-933f-45911274b913",
  "custom_vibesites_theme": "Vantage",
  "custom_ads_subscription": "none",
  "custom_rentcafe_chatbot": "<script type=\"text/javascript\" src=\"//webchat.omni.cafe/conversations/8a497492-95bd-47f6-984c-9e1b13c42df7/app.js?property=8a497492-95bd-47f6-984c-9e1b13c42df7&propertyName=Bridges+Apartment+Homes&channelUuid=c248e3a5-8dac-11ec-afb4-42010aa42b&buttonbgcolor=012345&buttonbgcolor=012345\" defer></script>",
  "custom_seo_subscription": "none",
  "custom_social_subscription": "none",
  "custom_website_subscription": "turnkey",
  "custom_apartmentsync_javascript_id": "eyJpdiI6IlVCZGdCWVJXRzFMMUVvZmgyQTRmRFE9PSIsInZhbHVlIjoiUlQ2UllxbWdIQkk4QWQ5S3VkNXozQT09IiwibWFjIjoiMDUwZjczZjE0ZGEyZmZjMDI0NzkzYjE5YjU3NGRmM2Y0OWJiMmE2MTU2ZTE1MjJkMmQyYzExZmE4ODEwNTQ4OSJ9",
  "custom_audioeye_site_id": "583c3abc-3fcd-4bfa-b1cb-b252a12e9cd4",
  "custom_audioeye_site_hash": "46371865f4e97a8182908de61adbbff6"
};

export const generatedAt = '2026-10-27T17:12:56.312Z';
